webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
    appVersion: 'v0.3.2',
    staticExposureData: '/static/data/static-exposure-data.json',
    usStateData: '/static/data/us-states.json',
    canadianProvinceData: '/static/data/canadian-provinces.json',
    formSubmitApi: '/data/submitContactForm.php',
    facebookAppId: ''
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(470),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad2f28f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "router", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ua__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ua___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ua__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_EventBusPlugin__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_MobileDetectPlugin__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_StorePlugin__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResidenceInteractive__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResidenceInteractive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ResidenceInteractive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MobileInteractive__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MobileInteractive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_MobileInteractive__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_EventBusPlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__plugins_MobileDetectPlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_StorePlugin__["a" /* default */]);

var mdInit = new __WEBPACK_IMPORTED_MODULE_7__plugins_MobileDetectPlugin__["a" /* default */].MobileDetect(window.navigator.userAgent);

var routes = [{
    name: 'home',
    path: '/',
    component: mdInit.phone() ? __WEBPACK_IMPORTED_MODULE_10__components_MobileInteractive___default.a : __WEBPACK_IMPORTED_MODULE_9__components_ResidenceInteractive___default.a
}];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    routes: routes,
    base: '/'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_ua___default.a, {
    appName: 'MBRe|Residential',
    appVersion: 'v1.0.0',
    trackingId: 'XXXXXXXXXXXXX',
    debug: false,
    vueRouter: router,
    ignoredViews: [],
    globalDimensions: [],
    globalMetrics: []
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    router: router,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_5__App___default.a);
    }
}).$mount('#app');

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(app.$dataStore, router);

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7472f74b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54c1a0d9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EventBus__ = __webpack_require__(226);


/* harmony default export */ __webpack_exports__["a"] = ({
    EventBus: __WEBPACK_IMPORTED_MODULE_0__components_EventBus__["a" /* EventBus */],
    install: function install(Vue, opts) {
        Vue.prototype.$eventBus = __WEBPACK_IMPORTED_MODULE_0__components_EventBus__["a" /* EventBus */];
    }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_detect__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobile_detect__);


/* harmony default export */ __webpack_exports__["a"] = ({
    MobileDetect: __WEBPACK_IMPORTED_MODULE_0_mobile_detect___default.a,
    install: function install(Vue, opts) {
        Vue.prototype.$md = new __WEBPACK_IMPORTED_MODULE_0_mobile_detect___default.a(window.navigator.userAgent);
    }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(227);


/* harmony default export */ __webpack_exports__["a"] = ({
    store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
    install: function install(Vue, opts) {
        Vue.prototype.$dataStore = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */];
    }
});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(472),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
  __webpack_require__(268)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(444),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cc4e2f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(287)
  __webpack_require__(286)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58f8c608",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OrientationWarning_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OrientationWarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_OrientationWarning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Overlay_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Overlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PowerSurgeButton_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PowerSurgeButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PowerSurgeButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PowerSurgeOverlay_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PowerSurgeOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PowerSurgeOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InteractionCTA_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InteractionCTA_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_InteractionCTA_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SidebarPanel_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SidebarPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SidebarPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SidebarControls_vue__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SidebarControls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SidebarControls_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppFooter__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Landing_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Landing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Landing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_OrientationWarningMobile__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_OrientationWarningMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_OrientationWarningMobile__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'app',

    components: {
        OrientationWarningMobile: __WEBPACK_IMPORTED_MODULE_10__components_OrientationWarningMobile___default.a,
        OrientationWarning: __WEBPACK_IMPORTED_MODULE_0__components_OrientationWarning_vue___default.a,
        Overlay: __WEBPACK_IMPORTED_MODULE_1__components_Overlay_vue___default.a,
        PowerSurgeButton: __WEBPACK_IMPORTED_MODULE_2__components_PowerSurgeButton_vue___default.a,
        PowerSurgeOverlay: __WEBPACK_IMPORTED_MODULE_3__components_PowerSurgeOverlay_vue___default.a,
        InteractionCta: __WEBPACK_IMPORTED_MODULE_4__components_InteractionCTA_vue___default.a,
        SidebarPanel: __WEBPACK_IMPORTED_MODULE_5__components_SidebarPanel_vue___default.a,
        SidebarControls: __WEBPACK_IMPORTED_MODULE_6__components_SidebarControls_vue___default.a,
        AppFooter: __WEBPACK_IMPORTED_MODULE_7__components_AppFooter___default.a,
        Landing: __WEBPACK_IMPORTED_MODULE_8__components_Landing_vue___default.a
    },

    data: function data() {
        return {
            controlsEntered: false,
            status: {
                err404: {
                    title: '404 - Page Not Found',
                    msg: 'The page you have requested cannot be found. Please check the URL in the address bar, or click back in your browser to return to your last location.'
                }
            }
        };
    },


    computed: {
        loading: function loading() {
            return this.$dataStore.state.loading;
        },
        loadingData: function loadingData() {
            return this.$dataStore.state.loadingData;
        },
        hasEntered: function hasEntered() {
            return this.$dataStore.state.interactive.entered;
        },
        isMobile: function isMobile() {
            return this.$md.phone();
        },
        has404: function has404() {
            return this.$dataStore.getters.get404Status;
        }
    },

    beforeCreate: function beforeCreate() {
        if (this.$md.phone()) {
            document.body.classList.add("mobile");
        }
    },
    created: function created() {
        //console.info('%capp::created', 'color:dodgerblue;');

        vm = this;

        vm.fetchData();

        vm.$eventBus.$on('controls:entered', vm.setControlsEntered);
    },
    mounted: function mounted() {
        //console.info('%capp::mounted', 'color:green;');

        vm = this;
    },

    methods: {
        fetchData: function fetchData() {
            this.$dataStore.dispatch('LOAD_APP_DATA');
        },
        setControlsEntered: function setControlsEntered() {
            this.controlsEntered = true;
        },
        transitionComplete: function transitionComplete() {
            this.controlsEntered = true;
            this.$eventBus.$emit('residence:resize', 0);
        }
    }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Branding_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'app-footer',

    components: {
        Branding: __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default.a
    },

    data: function data() {
        return {
            it: 'horizontal'
        };
    },


    computed: {
        loaded: function loaded() {
            return this.$dataStore.getters.getLoadedState;
        },
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        company: function company() {
            return this.$dataStore.getters.getCompany;
        },
        aboutPosition: function aboutPosition() {
            return this.$dataStore.getters.getAboutPosition;
        },
        activePanel: function activePanel() {
            return this.$dataStore.getters.getActivePanel;
        },
        hasCoverages: function hasCoverages() {
            var _coverages = this.$dataStore.getters.getCoverages;
            return _coverages.length > 0;
        },
        contact: function contact() {
            return this.$dataStore.getters.getCompanyContactData;
        },
        addCoverageLabel: function addCoverageLabel() {
            return this.$dataStore.getters.getAdditionalCoveragesLabel;
        },
        powerSurgeState: function powerSurgeState() {
            return this.$dataStore.getters.getPowerSurgeState;
        },
        powerSurgeOverlayState: function powerSurgeOverlayState() {
            return this.$dataStore.getters.getPowerSurgeOverlayState;
        }
    },

    created: function created() {
        //console.info('%cAppFooter::created', 'color:dodgerblue;');
        vm = this;

        this.$eventBus.$on('footer:image', function (it) {
            return vm.setIt(it);
        });
    },
    mounted: function mounted() {
        //console.info('%cAppFooter::mounted', 'color:green;');

        vm = this;
    },


    methods: {

        /**
         * @method togglePanel
         * @description
         * @param {String} type
         */
        togglePanel: function togglePanel(type, slug, evt) {

            if (vm.powerSurgeState && !vm.powerSurgeOverlayState) {
                return false;
            }

            if (vm.powerSurgeState) {
                this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                this.$dataStore.dispatch('POWER_SURGE', { val: false });
                this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                this.$eventBus.$emit('power-surge:end');
            }

            switch (type) {
                case 'panel-content-about':
                    vm.trackEvent('About Button', 'Footer');
                    break;
                case 'panel-content-coverages':
                    vm.trackEvent(vm.addCoverageLabel + ' Button');
                    break;
                case 'panel-content-contact':
                    vm.trackEvent(vm.contact.form_label + ' Button');
                    break;
                case 'panel-content-privacy':
                    vm.trackEvent('Legal Link', 'Privacy Policy');
                    break;
                case 'panel-content-terms':
                    vm.trackEvent('Legal Link', 'Terms and Conditions');
                    break;
            }

            //console.info('%ctogglePanel', 'color:orange;');
            evt.stopPropagation();
            this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug });
        },
        setIt: function setIt(it) {
            vm.it = it;
        },
        trackEvent: function trackEvent(action, label) {
            gtag('event', action, {
                'event_category': 'MBRe: Residential',
                'event_label': label || ''
            });
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_images_loaded__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_images_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_images_loaded__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'branding',

    props: ['logo', 'altText', 'link', 'linkTarget', 'addClass'],

    directives: {
        imagesLoaded: __WEBPACK_IMPORTED_MODULE_0_vue_images_loaded___default.a
    },

    components: {},

    data: function data() {
        return {
            imageSrc: this.logo.x1.url,
            imageSrcSet: this.logo.x1.url + ' 1x,' + this.logo.x2.url + ' 2x,' + this.logo.x3.url + ' 3x',
            imageSize: null,
            imageThreshold: 1.5,
            imageOrientationClass: 'horizontal'
        };
    },


    computed: {
        target: function target() {
            return this.linkTarget ? this.linkTarget : '_blank';
        },
        pageHref: function pageHref() {
            return '/' + window.location.search;
        }
    },

    created: function created() {
        //console.info('%cBranding::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%cBranding::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        imageProgress: function imageProgress(ins, img) {
            var result = img.isLoaded ? 'loaded' : 'broken';

            vm.imageSize = {
                width: img.img.width,
                height: img.img.height
            };

            var _ratio = vm.imageSize.width / vm.imageSize.height;

            if (_ratio < vm.imageThreshold) {
                vm.imageOrientationClass = 'vertical';
            }

            vm.$eventBus.$emit('footer:image', vm.imageOrientationClass);

            setTimeout(function () {
                vm.$eventBus.$emit('branding:loaded');
            }, 2000);
        },
        getImgSrcSet: function getImgSrcSet(logo) {
            return logo.x1.url + ' 1x,' + logo.x2.url + ' 2x,' + logo.x3.url + ' 3x';
        },
        trackEvent: function trackEvent() {
            gtag('event', 'Company Logo Image', {
                'event_category': 'MBRe: Residential',
                'event_label': ''
            });
        }
    }

});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'exposures-carousel',

    props: {
        selectedSlug: {
            type: String,
            default: null
        }
    },

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        exposures: function exposures() {
            var _exposures = this.$dataStore.getters.getExposures;
            // alpha sort by label
            _exposures = _.sortBy(_exposures, ['exposure_label']);
            return _exposures;
        },
        filteredExposures: function filteredExposures() {
            return _.filter(vm.exposures, function (obj) {
                return obj.exposure_slug !== vm.selectedSlug;
            });
        }
    },

    created: function created() {
        vm = this;
    },
    mounted: function mounted() {
        vm = this;

        /*setTimeout(function() {
            vm.initCarousel();
        }, 250);*/
    },


    methods: {
        initCarousel: function initCarousel() {
            $('.exposures-carousel .carousel-items').slick({
                infinite: false,
                swipeToSlide: true,
                slidesToShow: 3,
                variableWidth: true
            });
        },
        getExposure: function getExposure(slug) {
            console.log('getExposure', slug);

            this.$eventBus.$emit('exposure:get', slug);

            $('html, body').animate({ scrollTop: 0 }, 600);
        },
        exposureClosed: function exposureClosed() {
            vm.selectedSlug = null;
            $('html, body').animate({ scrollTop: 0 }, 600);
            vm.animateGridItems(300);
        },


        /**
         * @method getCSSColorVariable
         * @description
         * @param color
         * @return {string}
         */
        getCSSColorVariable: function getCSSColorVariable(color) {
            var _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

            if (!_propVal) {
                var _color = color.replace('--', '$');
                _propVal = window.appTheme.colors[_color];
            }

            //console.log('_propVal', _propVal);

            return _propVal;
        },


        /**
         * @method cssPropColor
         * @description
         */
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        },
        isOdd: function isOdd(num) {
            return num % 2;
        }
    }

});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'interaction-cta',

    components: {},

    data: function data() {
        return {
            message: 'Click and drag your mouse to explore the full coverage of the Equipment Breakdown example home.',
            display: false
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.state.interactive.entered;
        },
        instructed: function instructed() {
            return this.$dataStore.getters.getInstructedState;
        },
        surgeState: function surgeState() {
            return this.$dataStore.getters.getPowerSurgeState;
        },
        isTablet: function isTablet() {
            return !!vm.$md.tablet();
        }
    },

    created: function created() {
        //console.info('%cInteractionCTA::created', 'color:dodgerblue;');

        vm = this;

        this.$eventBus.$on('cta:show', vm.show);
        this.$eventBus.$on('cta:hide', vm.hide);
    },
    mounted: function mounted() {
        //console.info('%cInteractionCTA::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        show: function show() {
            if (!this.surgeState && !this.instructed) {
                this.display = true;
                this.$dataStore.dispatch('INSTRUCTED', { val: true });
                'mousedown touchmove'.split(' ').forEach(function (evt) {
                    window.addEventListener(evt, vm.hide, false);
                });
            }
        },
        hide: function hide() {
            this.display = false;
        }
    }

});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'landing',

    components: {
        ProgressButton: __WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue___default.a
    },

    data: function data() {
        return {
            buttonLabel: 'Enter Experience',
            loadingLabel: 'Constructing Experience',
            unsupported: {
                heading: 'Oops',
                msg: 'It seems the browser you are using is incompatible with our website. Please update your browser to continue.'
            },
            status: {
                err404: {
                    title: '404 - Page Not Found',
                    msg: 'The page you have requested cannot be found. Please check the URL in the address bar, or click back in your browser to return to your last location.'
                }
            }
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        hasLoaded: function hasLoaded() {
            return this.$dataStore.getters.getLoadedState;
        },
        landing: function landing() {
            return this.$dataStore.getters.getLandingData;
        },
        hasSupport: function hasSupport() {
            return Modernizr.canvas && Modernizr.flexbox && Modernizr.video;
        },
        has404: function has404() {
            return this.$dataStore.getters.get404Status;
        }
    },

    created: function created() {},
    mounted: function mounted() {
        vm = this;
    },


    methods: {

        /**
         * @method openSesame
         * @description
         */
        openSesame: function openSesame() {

            gtag('event', 'Enter Experience Click', {
                'event_category': 'MBRe: Residential',
                'event_label': ''
            });

            this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: !this.$dataStore.state.interactive.entered });
            this.$eventBus.$emit('residence:transition:in');
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-content-contact',

    props: ['panel'],

    components: {},

    data: function data() {
        return {
            title: 'Contact Us',
            emailLabel: 'Click Here to Email Us',
            contactUrlLabel: 'Contact Us',
            submitted: false,
            submitting: false,
            form: {
                country: 'US'
            }
        };
    },


    computed: {
        contact: function contact() {
            return this.$dataStore.getters.getCompanyContactData;
        },
        hasContactFields: function hasContactFields() {
            return _.find(this.contact.form_fields, { visible: '1' });
        },
        stateProvinceOptions: function stateProvinceOptions() {
            return {
                'US': this.$dataStore.getters.getUSStateData,
                'CA': this.$dataStore.getters.getCanadianProvinceData
            };
        },
        stateProvinceLabel: function stateProvinceLabel() {
            return this.form.country === 'US' ? 'State' : 'Province';
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        isContactEmail: function isContactEmail(val) {
            var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
            return re.test(val);
        },
        contactFieldTypeBySlug: function contactFieldTypeBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.type;
        },
        contactFieldLabelBySlug: function contactFieldLabelBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.label + (field.required === '1' ? '*' : '');
        },
        contactFieldRequiredBySlug: function contactFieldRequiredBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.required === '1';
        },
        contactFieldVisibleBySlug: function contactFieldVisibleBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.visible === '1';
        },
        backToExposures: function backToExposures() {
            $('.nav-tabs li:first-of-type').trigger('click');
        },
        handleFormSubmit: function handleFormSubmit(evt) {
            console.info('handleFormSubmit', evt);

            vm.submitting = true;

            // gather the form contents
            var _form = $('#' + evt.target.id),
                _formContents = _form.serialize();

            // submit form data
            $.ajax({
                url: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].formSubmitApi,
                type: 'POST',
                data: _formContents,
                success: function success(res) {

                    console.info('The form was successfully submitted.', res);

                    gtag('event', 'Contact Form Submission', {
                        'event_category': 'MBRe: Residential',
                        'event_label': ''
                    });

                    // reset form input
                    _form[0].reset();

                    // re-enable submit buttons & kill sending msg
                    vm.submitting = true;

                    // set form submitted to true, will trigger thank you msg.
                    vm.submitted = true;
                },
                error: function error(xhr, status, err) {

                    console.error('There was an error submitting the form.', xhr, status, err);

                    // re-enable submit buttons & kill sending msg
                    vm.submitting = false;
                }
            });
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-content-coverages',

    props: ['panel', 'slug', 'service', 'premise'],

    components: {},

    data: function data() {
        return {
            contact: {
                text: 'Ready to take the next step?',
                link: {
                    label: 'Contact us today'
                }
            }
        };
    },


    computed: {
        coverages: function coverages() {
            return this.$dataStore.getters.getCoverages;
        },
        addCoverageLabel: function addCoverageLabel() {
            return this.$dataStore.getters.getAdditionalCoveragesLabel;
        },
        serviceLineLabel: function serviceLineLabel() {
            return this.$dataStore.getters.getServiceLineCoverageLabel;
        },
        serviceLineLeadIn: function serviceLineLeadIn() {
            var _occupancies = this.$dataStore.getters.getOccupancies;
            return _occupancies.occupancy_service_line_lead_in;
        },
        serviceLineCoverages: function serviceLineCoverages() {
            var coverages = this.$dataStore.getters.getCoveragesByType('service-line');
            return _.sortBy(coverages, ['exposure_label']);
        },
        hasServiceLineCoverages: function hasServiceLineCoverages() {
            return this.$dataStore.getters.getServiceLineCoverages.length;
        },
        offPremiseLabel: function offPremiseLabel() {
            return this.$dataStore.getters.getOffPremiseCoverageLabel;
        },
        offPremiseLeadIn: function offPremiseLeadIn() {
            var _occupancies = this.$dataStore.getters.getOccupancies;
            return _occupancies.occupancy_off_premise_lead_in;
        },
        offPremiseCoverages: function offPremiseCoverages() {
            var coverages = this.$dataStore.getters.getCoveragesByType('off-premise');
            return _.sortBy(coverages, ['exposure_label']);
        },
        hasOffPremiseCoverages: function hasOffPremiseCoverages() {
            return this.$dataStore.getters.getOffPremisesCoverages.length;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-coverages::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-coverages::mounted', 'color:green;');

        vm = this;

        // scroll to tab & check it
        var _s = vm.slug,
            _checkEl = document.querySelectorAll('[data-coverage="' + _s + '"]')[0];
        if (typeof _checkEl !== 'undefined') {
            _checkEl.checked = true;
            vm.scrollToAnchor(vm.slug);
        }

        vm.playVideo();
        vm.initCarousel();
    },


    methods: {
        playVideo: function playVideo() {
            var _video = $('.video-player-element');

            if (!_video.length) {
                return;
            }

            _.each(_video, function (val, key) {

                // video `canplay` event handler
                $(val).on('canplay', function () {
                    $(val).trigger('play');
                });

                // check `readyState` in case video element has already been init'd/cached
                if ($(val)[0].readyState > 3) {
                    $(val).trigger('play');
                }
            });
        },
        initCarousel: function initCarousel() {

            var _carousel = $('.image-carousel');

            if (!_carousel.length) {
                return;
            }

            vm.carousel = true;

            _.each(_carousel, function (val, key) {

                $(val).slick({
                    autoplay: true,
                    arrows: false,
                    adaptiveHeight: true,
                    pauseOnHover: false,
                    pauseOnFocus: false
                });
            });
        },
        scrollToAnchor: function scrollToAnchor(slug) {

            var _anchorId = 'anchor_' + slug,
                _anchorEl = document.getElementById(_anchorId);

            var requestAnimFrame = function () {
                return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
            }();

            Math.easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) {
                    return c / 2 * t * t + b;
                }
                t--;
                return -c / 2 * (t * (t - 2) - 1) + b;
            };

            Math.easeInCubic = function (t, b, c, d) {
                var tc = (t /= d) * t * t;
                return b + c * tc;
            };

            Math.inOutQuintic = function (t, b, c, d) {
                var ts = (t /= d) * t,
                    tc = ts * t;
                return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
            };

            function isDomElement(obj) {
                return obj instanceof Element;
            }

            function scrollTo(to, callback) {
                var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1500;


                if (isDomElement(to)) {
                    to = to.offsetTop;
                }

                // because it's so fucking difficult to detect the scrolling element, just move them all
                function move(amount) {
                    document.documentElement.scrollTop = amount;
                    document.body.parentNode.scrollTop = amount;
                    document.body.scrollTop = amount;
                }

                function position() {
                    return document.documentElement.offsetTop || document.body.parentNode.offsetTop || document.body.offsetTop;
                }

                var start = position(),
                    change = to - start,
                    currentTime = 0,
                    increment = 20;

                var animateScroll = function animateScroll() {
                    // increment the time
                    currentTime += increment;
                    // find the value with the quadratic in-out easing function
                    var val = Math.easeInOutQuad(currentTime, start, change, duration);
                    // move the document.body
                    move(val);
                    // do the animation unless its over
                    if (currentTime < duration) {
                        requestAnimFrame(animateScroll);
                    } else {
                        if (callback && typeof callback === 'function') {
                            // the animation is done so lets callback
                            callback();
                        }
                    }
                };

                animateScroll();
            }

            scrollTo(_anchorEl);
        },
        toggleCheck: function toggleCheck(evt, slug) {

            $('.image-carousel').slick('setPosition');

            var _checks = $('input[name="tabs-service[]"]');

            _.each(_checks, function (val) {
                if (evt.currentTarget.id !== $(val).attr('id')) {
                    $(val).prop('checked', false);
                }
            });

            vm.scrollToAnchor(slug);
        },
        toggleOuterCheck: function toggleOuterCheck(evt, slug) {

            $('.image-carousel').slick('setPosition');

            var _checks = $('input[name="outer-tabs[]"]');

            _.each(_checks, function (val) {
                if (evt.currentTarget.id !== $(val).attr('id')) {
                    $(val).prop('checked', false);
                }
            });

            vm.scrollToAnchor(slug);
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} type
         * @param {String} slug
         * @param {Object} evt
         * @param {Boolean} service
         * @param {Boolean} premise
         */
        togglePanel: function togglePanel(type, slug, evt, service, premise) {
            evt.stopPropagation();
            this.$eventBus.$emit('tab:change', 'Exposures', type, slug);
            setTimeout(function () {
                vm.$eventBus.$emit('exposure:get', slug);
            }, 0);
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {},

    beforeDestroy: function beforeDestroy() {
        if (vm.carousel) {
            $('.image-carousel').slick('unslick');
        }
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExposuresCarousel_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExposuresCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ExposuresCarousel_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-content-exposure',

    props: ['panel', 'slug', 'service', 'premise'],

    components: { ExposuresCarousel: __WEBPACK_IMPORTED_MODULE_0__ExposuresCarousel_vue___default.a },

    data: function data() {
        return {
            carousel: false,
            contact: {
                text: 'Ready to take the next step?',
                link: {
                    label: 'Contact us today'
                }
            },
            videoType: 'video/mp4'
        };
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getExposureBySlug(this.slug);
        },
        disclaimer: function disclaimer() {
            return this.$dataStore.getters.getExposureDisclaimer;
        },
        headerLabel: function headerLabel() {
            var _l = this.content.exposure_label,
                _s = this.content.exposure_slug,
                _c = this.content.coverage,
                _t = this.content.exposure_type;

            if (_s === 'laptop' && _t === 'off-premise' && _c) {
                return this.labelOffPremise + ': ' + _l;
            }

            return _l;
        },
        addCoverageLabel: function addCoverageLabel() {
            return this.$dataStore.getters.getAdditionalCoveragesLabel;
        },
        coverageContent: function coverageContent() {
            return this.$dataStore.getters.getCoverageContent;
        },
        labelOffPremise: function labelOffPremise() {
            return this.$dataStore.getters.getOffPremiseCoverageLabel;
        },
        labelServiceLine: function labelServiceLine() {
            return this.$dataStore.getters.getServiceLineCoverageLabel;
        },
        videoSource: function videoSource() {
            return '<source src="' + this.content.media.sources[0] + '" type="' + this.videoType + '" />';
        }
    },

    created: function created() {
        console.info('%cmobile-content-exposure::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        console.info('%cmobile-content-exposure::mounted', 'color:green;');

        console.log('this.content', this.content);

        this.$eventBus.$emit('footer:disclaimer:show');

        vm = this;

        // play video if we gotz one
        if (vm.content.media.type === 'video') {
            setTimeout(function () {
                vm.playVideo();
            }, 2000);
        }

        // init carousel if we gotz images
        if (vm.content.media.type === 'images') {
            setTimeout(function () {
                vm.initCarousel();
            }, 100);
        }
    },


    methods: {
        playVideo: function playVideo() {
            var _video = $('#video-player'),
                _videoEl = _video[0];

            // video `canplay` event handler
            _video.on('canplay', function () {
                _video.trigger('play');
            });

            // check `readyState` in case video element has already been init'd/cached
            if (_videoEl.readyState > 3) {
                _video.trigger('play');
            }
        },
        initCarousel: function initCarousel() {
            vm.carousel = true;
            $('.image-carousel').slick({
                infinite: false,
                arrows: false,
                slideToScroll: -1,
                adaptiveHeight: true,
                variableWidth: true,
                waitForAnimate: false
            });
        },
        trackEvent: function trackEvent(action, label) {
            gtag('event', action, {
                'event_category': 'MBRe: Residential',
                'event_label': label || ''
            });
        },
        closeExposure: function closeExposure() {
            this.$eventBus.$emit('exposure:closed');
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} tab
         * @param {String} type
         * @param {Boolean} opt
         */
        togglePanel: function togglePanel(tab, type, opt) {
            type = type || null;
            this.$eventBus.$emit('tab:change', tab, type, opt);
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {},

    beforeDestroy: function beforeDestroy() {

        this.$eventBus.$emit('footer:disclaimer:hide');

        if (vm.carousel) {
            $('.image-carousel').slick('unslick');
        }
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileContentExposure_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileContentExposure_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MobileContentExposure_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-content-exposures',

    components: { MobileContentExposure: __WEBPACK_IMPORTED_MODULE_0__MobileContentExposure_vue___default.a },

    data: function data() {
        return {
            banner: {
                heading: 'Is your equipment covered?',
                copy: 'Select an exposure below to see how you can help protect your home.'
            },
            selectedSlug: null,
            selectedService: null,
            selectedPremise: null
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        exposures: function exposures() {
            var _exposures = this.$dataStore.getters.getExposures;
            // alpha sort by label
            _exposures = _.sortBy(_exposures, ['exposure_label']);
            return _exposures;
        }
    },

    created: function created() {
        console.info('%cmobile-content-exposures::created', 'color:dodgerblue;');

        vm = this;

        this.$eventBus.$on('exposures:enabled', function () {
            setTimeout(function () {
                vm.animateGridItems(0);
            }, 200);
        });
        this.$eventBus.$on('exposure:closed', vm.exposureClosed);
        this.$eventBus.$on('exposure:return', vm.exposureReturn);
        this.$eventBus.$on('exposure:get', function (slug) {
            return vm.getExposure(slug);
        });
        this.$eventBus.$on('slug:none', vm.selectNone);
    },
    mounted: function mounted() {
        console.info('%cmobile-content-exposures::mounted', 'color:green;');

        vm = this;

        if (!vm.hasEntered) {
            $('.tab-content').addClass('inactive');
        }

        if (vm.selectedSlug) {
            $('.grid-component').addClass('inactive');
        } else {
            $('.grid-component').removeClass('inactive');
        }
    },


    watch: {
        selectedSlug: function selectedSlug(val) {
            if (val) {
                console.log('selectedSlug[0]', val);
                $('.grid-component').addClass('inactive');
            } else {
                console.log('selectedSlug[1]', val);
                $('.grid-component').removeClass('active');
            }
        }
    },

    methods: {
        getExposure: function getExposure(slug) {
            console.log('getExposure', slug);
            vm.selectedSlug = slug;

            var _exposure = _.find(vm.exposures, { 'exposure_slug': slug });

            gtag('event', 'Equipment Selection', {
                'event_category': 'MBRe: Residential',
                'event_label': _exposure.exposure_name
            });

            vm.selectedService = _exposure.exposure_type === 'service-line';
            vm.selectedPremise = _exposure.exposure_type === 'off-premise';

            //$('html,body').scrollTop(0);
            $('html, body').animate({ scrollTop: 0 }, 200);
        },
        exposureClosed: function exposureClosed() {
            vm.selectedSlug = null;

            $('html, body').animate({ scrollTop: 0 }, 200, function () {
                vm.animateGridItems(300);
            });
        },
        exposureReturn: function exposureReturn() {
            vm.selectedSlug = null;

            $('html, body').animate({ scrollTop: 0 }, 200);
        },
        selectNone: function selectNone() {
            vm.selectedSlug = null;
        },
        animateGridItems: function animateGridItems(delay) {

            var _delay = delay || 0;

            function animateItems() {
                var tl = new TimelineMax();

                _.each($('.grid-item'), function (val, key) {

                    var _durationOffset = vm.isOdd(key) ? '-=0.3' : '-=0';

                    tl.fromTo($(val), 0.3, {
                        opacity: 0,
                        y: '-=80'
                    }, {
                        opacity: 1,
                        y: 0
                    }, _durationOffset);
                });
            }

            setTimeout(function () {
                animateItems();
            }, _delay);
        },
        scrollToTop: function scrollToTop() {
            $('html, body').animate({ scrollTop: 0 }, 400);
        },


        /**
         * @method getCSSColorVariable
         * @description
         * @param color
         * @return {string}
         */
        getCSSColorVariable: function getCSSColorVariable(color) {
            var _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

            if (!_propVal) {
                var _color = color.replace('--', '$');
                _propVal = window.appTheme.colors[_color];
            }

            //console.log('_propVal', _propVal);

            return _propVal;
        },


        /**
         * @method cssPropColor
         * @description
         */
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        },
        isOdd: function isOdd(num) {
            return num % 2;
        }
    }

});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-content-privacy',

    props: ['panel'],

    components: {},

    data: function data() {
        return {
            title: 'Privacy Policy'
        };
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getPrivacyData;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-content-terms',

    props: ['panel'],

    components: {},

    data: function data() {
        return {
            title: 'Terms and Conditions'
        };
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getTermsData;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Branding_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_nav_tabs_themes_vue_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MobileContentContact_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MobileContentContact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MobileContentContact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MobileContentPrivacy_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MobileContentPrivacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MobileContentPrivacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MobileContentTerms_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MobileContentTerms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MobileContentTerms_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MobileContentCoverages_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MobileContentCoverages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MobileContentCoverages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MobileContentExposures_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MobileContentExposures_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MobileContentExposures_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileLanding_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileLanding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__MobileLanding_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sticky_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sticky_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sticky_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShareControls__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShareControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ShareControls__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-interactive',

    components: {
        ShareControls: __WEBPACK_IMPORTED_MODULE_11__ShareControls___default.a,
        MobileLanding: __WEBPACK_IMPORTED_MODULE_9__MobileLanding_vue___default.a,
        MobileContentExposures: __WEBPACK_IMPORTED_MODULE_8__MobileContentExposures_vue___default.a,
        MobileContentCoverages: __WEBPACK_IMPORTED_MODULE_7__MobileContentCoverages_vue___default.a,
        MobileContentTerms: __WEBPACK_IMPORTED_MODULE_6__MobileContentTerms_vue___default.a,
        MobileContentPrivacy: __WEBPACK_IMPORTED_MODULE_5__MobileContentPrivacy_vue___default.a,
        MobileContentContact: __WEBPACK_IMPORTED_MODULE_4__MobileContentContact_vue___default.a,
        Branding: __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default.a,
        VueTabs: __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__["VueTabs"],
        VTab: __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__["VTab"]
    },

    data: function data() {
        return {
            zoomed: false,
            residenceImage: '/static/images/MBR-055_House-Layered_Base.jpg',
            exposureObjects: {},
            contact: {
                text: 'Ready to take the next step?',
                link: {
                    label: 'Contact us today'
                },
                show: true
            },
            tabName: null,
            panelOpen: false,
            stickyHeader: null,
            stickyNav: null,
            disclaimerActive: false,
            shouldHideGrid: false
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        loaded: function loaded() {
            return this.$dataStore.getters.getLoadedState;
        },
        company: function company() {
            return this.$dataStore.getters.getCompany;
        },
        exposures: function exposures() {
            return this.$dataStore.getters.getExposures;
        },
        hasCoverages: function hasCoverages() {
            var _coverages = this.$dataStore.getters.getCoverages;
            return _coverages.length > 0;
        },
        contactData: function contactData() {
            return this.$dataStore.getters.getCompanyContactData;
        },
        addCoverageLabel: function addCoverageLabel() {
            return this.$dataStore.getters.getAdditionalCoveragesLabel;
        },
        disclaimer: function disclaimer() {
            return this.$dataStore.getters.getExposureDisclaimer;
        }
    },

    created: function created() {
        //console.info('%cMobileInteractive::created', 'color:dodgerblue;');
        vm = this;

        this.$eventBus.$on('footer:disclaimer:show', vm.showDisclaimer);
        this.$eventBus.$on('footer:disclaimer:hide', vm.hideDisclaimer);

        this.$eventBus.$on('footer:contact:show', vm.showContact);
        this.$eventBus.$on('footer:contact:hide', vm.hideContact);

        this.$eventBus.$on('tab:change', function (tab, type, opt) {
            return vm.changeTab(tab, type, opt);
        });

        this.$eventBus.$on('branding:loaded', vm.stickIt);

        if (/webkit.*mobile/i.test(navigator.userAgent)) {
            (function ($) {
                $.fn.offsetOld = $.fn.offset;
                $.fn.offset = function () {
                    var result = this.offsetOld();
                    result.top -= window.scrollY;
                    result.left -= window.scrollX;
                    return result;
                };
            })(jQuery);
        }
    },
    mounted: function mounted() {
        //console.info('%cMobileInteractive::mounted', 'color:green;');
        vm = this;

        // loaded
        vm.$dataStore.dispatch('LOADED', { val: true });

        $('.main').on('click', '.nav-tabs li', function () {
            vm.hidePanels();
        });
    },


    watch: {
        panelOpen: function panelOpen(val) {
            if (vm.panelOpen) {
                $('.tab-content').addClass('inactive');
            } else {
                $('.tab-content').removeClass('inactive');
            }
        }
    },

    methods: {
        stickIt: function stickIt() {
            var mHeight = $('header').height();
            $('.nav-tabs-navigation').attr('data-sticky-wrap', '').attr('data-margin-top', mHeight).addClass('sticky');
            vm.stickyHeader = new __WEBPACK_IMPORTED_MODULE_10_sticky_js___default.a('.sticky');
            vm.stickyHeader.update();
        },
        changeTab: function changeTab(tab, type, opt) {

            vm.hidePanels();
            vm.tabName = tab;
            console.log('tab', tab);
            console.log('type', type);
            console.log('opt', opt);

            if (type) {
                switch (type) {
                    case 'off-premise':

                        setTimeout(function () {

                            var _header = $('header'),
                                _tabs = $('.nav-tabs-navigation'),
                                _headerHeight = typeof _header !== 'undefined' ? _header.height() : 0,
                                _tabHeight = typeof _tabs !== 'undefined' ? _tabs.height() : 0;

                            console.log('type', type);
                            console.log('_headerHeight', _headerHeight);
                            console.log('_tabHeight', _tabHeight);
                            console.log('$(\'#anchor_\' + type)', $('#anchor_' + type));
                            console.log('$(\'#anchor_\' + type).offset().top', Math.ceil($('#anchor_' + type).offset().top));
                            console.log('Math.ceil((($(\'#anchor_\' + type).offset().top) - (_headerHeight + _tabHeight)) - 30)', Math.ceil($('#anchor_' + type).offset().top - (_headerHeight + _tabHeight) - 30));

                            $('html, body').animate({
                                scrollTop: Math.ceil($('#anchor_' + type).offset().top - (_headerHeight + _tabHeight) - 30)
                            }, 300);
                        }, 600);
                        break;
                    case 'service-line':

                        break;
                }
            }
        },
        handleTabChange: function handleTabChange(idx, nTab, oTab) {
            console.log(idx, nTab, oTab);
            this.$eventBus.$emit('exposure:return');
            this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: true });
            $('.tab-content').removeClass('inactive');

            var numTabs = $('.nav-tabs .tab').length;

            switch (idx) {
                case 0:
                    vm.trackEvent('Exposures Button');
                    this.$eventBus.$emit('exposures:enabled');
                    this.$eventBus.$emit('footer:contact:show');
                    break;
                case 1:
                    if (numTabs === 3) {
                        vm.trackEvent('Additional Coverages Button');
                        this.$eventBus.$emit('footer:contact:show');
                    } else if (numTabs === 2) {
                        vm.trackEvent('Contact Us Button');
                        this.$eventBus.$emit('footer:contact:hide');
                    }
                    break;
                case 2:
                    vm.trackEvent('Contact Us Button');
                    this.$eventBus.$emit('footer:contact:hide');
                    break;
            }
        },
        showPanel: function showPanel(panel) {
            $('html,body').scrollTop(0);
            vm.panelOpen = true;
            $('.panel-content section').removeClass('active');
            $('.panel-content section[data-type="' + panel + '"]').addClass('active');

            /*setTimeout(function() {
                $('html,body').scrollTop(0);
            }, 150);*/
        },
        hidePanels: function hidePanels() {
            $('html,body').scrollTop(0);
            /*setTimeout(function() {
                $('html,body').scrollTop(0);
            }, 150);*/

            vm.panelOpen = false;
            $('.panel-content section').removeClass('active');
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} type
         * @param {String} slug
         * @param {String} service
         * @param {String} premise
         */
        togglePanel: function togglePanel(type, slug, service, premise) {
            //console.info('%ctogglePanel', 'color:orange;', type, slug, premise);

            this.$eventBus.$emit('panel:toggle', {
                panel: type,
                slug: slug,
                service: service,
                premise: premise
            });
        },


        /**
         * @method showContact
         * @description
         */
        showContact: function showContact() {
            vm.contact.show = true;
        },


        /**
         * @method hideContact
         * @description
         */
        hideContact: function hideContact() {
            vm.contact.show = false;
        },
        showDisclaimer: function showDisclaimer() {
            vm.disclaimerActive = true;
        },
        hideDisclaimer: function hideDisclaimer() {
            vm.disclaimerActive = false;
        },


        /**
         * @method shareApp
         * @description
         */
        shareApp: function shareApp() {
            //console.info('%cshareApp', 'color:orange;');
            this.$eventBus.$emit('share:toggle');
        },
        trackEvent: function trackEvent(action, label) {
            gtag('event', action, {
                'event_category': 'MBRe: Residential',
                'event_label': label || ''
            });
        },


        /**
         * @method getCSSColorVariable
         * @description
         * @param color
         * @return {string}
         */
        getCSSColorVariable: function getCSSColorVariable(color) {
            var _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

            if (!_propVal) {
                var _color = color.replace('--', '$');
                _propVal = window.appTheme.colors[_color];
            }

            //console.log('_propVal', _propVal);

            return _propVal;
        },


        /**
         * @method cssPropColor
         * @description
         */
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        },


        /**
         * @method timeStampMs
         * @description
         * @return {number}
         */
        timeStampMs: function timeStampMs() {
            return window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
        }
    }

});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'mobile-landing',

    components: {
        ProgressButton: __WEBPACK_IMPORTED_MODULE_0__ProgressButton_vue___default.a
    },

    data: function data() {
        return {
            houseImage: '/static/images/mbr-house-mobile.png',
            buttonLabel: 'View Exposures',
            loadingLabel: 'Constructing Experience',
            unsupported: {
                heading: 'Oops',
                msg: 'It seems the browser you are using is incompatible with our website. Please update your browser to continue.'
            }
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.state.interactive.entered;
        },
        landing: function landing() {
            return this.$dataStore.getters.getLandingData;
        },
        hasSupport: function hasSupport() {
            return Modernizr.canvas && Modernizr.flexbox && Modernizr.video;
        },
        aboutContent: function aboutContent() {
            return this.$dataStore.getters.getAboutContent;
        }
    },

    created: function created() {},
    mounted: function mounted() {
        vm = this;
    },


    methods: {

        /**
         * @method openSesame
         * @description
         */
        openSesames: function openSesames() {
            console.log('openSesames');
            this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: true });
            $('.tab-content').removeClass('inactive');

            setTimeout(function () {
                $('.nav-tabs li:first-of-type').trigger('click');
            }, 250);
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Branding_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'orientation-warning',

    components: {
        Branding: __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default.a
    },

    data: function data() {
        return {
            isLandscape: false,
            content: {
                heading: 'Turn Your Tablet',
                text: 'In order to interact with the Homeowners Equipment Breakdown experience, please turn your tablet to the horizontal position.'
            }
        };
    },
    created: function created() {
        vm = this;
    },


    computed: {
        loaded: function loaded() {
            return this.$dataStore.getters.getLoadedState;
        },
        company: function company() {
            return this.$dataStore.getters.getCompany;
        }
    },

    mounted: function mounted() {
        window.addEventListener("orientationchange", vm.isMobileLandscape, false);
        vm.isMobileLandscape();
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("orientationchange", vm.isMobileLandscape, false);
    },


    methods: {

        /**
         * @method isMobileLandscape
         * @description
         */
        isMobileLandscape: function isMobileLandscape() {
            setTimeout(function () {
                vm.isLandscape = vm.$md.tablet() && window.innerWidth < window.innerHeight;
            }, 250);
        },


        /**
         * @method cssPropColor
         * @description
         * @param {String} colorProp
         * @return {boolean}
         */
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Branding_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'orientation-warning-mobile',

    components: {
        Branding: __WEBPACK_IMPORTED_MODULE_0__Branding_vue___default.a
    },

    data: function data() {
        return {
            isPortrait: true,
            is404: false,
            content: {
                heading: 'Turn Your Phone',
                text: 'In order to interact with the Homeowners Equipment Breakdown experience, please turn your phone to the vertical position.'
            }
        };
    },
    created: function created() {
        vm = this;
    },


    computed: {
        loaded: function loaded() {
            return this.$dataStore.getters.getLoadedState;
        },
        company: function company() {
            return this.$dataStore.getters.getCompany;
        },
        has404: function has404() {
            vm.is404 = this.$dataStore.getters.get404Status;
            return vm.is404;
        }
    },

    mounted: function mounted() {
        window.addEventListener("orientationchange", vm.isMobilePortrait, false);
        vm.isMobilePortrait();
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("orientationchange", vm.isMobilePortrait, false);
    },


    methods: {

        /**
         * @method isMobilePortrait
         * @description
         */
        isMobilePortrait: function isMobilePortrait() {
            setTimeout(function () {
                vm.isPortrait = window.innerHeight > window.innerWidth;

                if (vm.isPortrait) {
                    console.log('We are in portrait orientation.');
                } else {
                    console.log('We are in landscape orientation.');
                }
            }, 250);
        },


        /**
         * @method cssPropColor
         * @description
         * @param {String} colorProp
         * @return {boolean}
         */
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'overlay',

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        hasLoaded: function hasLoaded() {
            return this.$dataStore.getters.getLoadedState;
        }
    },

    created: function created() {},
    mounted: function mounted() {
        vm = this;
    },


    methods: {

        /**
         * @method openSesame
         * @description
         */
        openSesame: function openSesame() {
            if (this.hasLoaded) {
                gtag('event', 'Enter Experience Click', {
                    'event_category': 'MBRe: Residential',
                    'event_label': ''
                });

                this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: !this.$dataStore.state.interactive.entered });
                this.$eventBus.$emit('residence:transition:in');
            }
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-about',

    props: ['title', 'panel'],

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getAboutContent;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-contact',

    props: ['panel'],

    components: {},

    data: function data() {
        return {
            submitted: false,
            submitting: false,
            form: {
                country: 'US'
            },
            contactUrlLabel: 'Contact Us'
        };
    },


    computed: {
        contact: function contact() {
            return this.$dataStore.getters.getCompanyContactData;
        },
        hasContactFields: function hasContactFields() {
            return _.find(this.contact.form_fields, { visible: '1' });
        },
        stateProvinceOptions: function stateProvinceOptions() {
            return {
                'US': this.$dataStore.getters.getUSStateData,
                'CA': this.$dataStore.getters.getCanadianProvinceData
            };
        },
        stateProvinceLabel: function stateProvinceLabel() {
            return this.form.country === 'US' ? 'State' : 'Province';
        }
    },

    created: function created() {
        //console.info('%csidebar-content-contact::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-contact::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        isContactEmail: function isContactEmail(val) {
            var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
            return re.test(val);
        },
        contactFieldTypeBySlug: function contactFieldTypeBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.type;
        },
        contactFieldLabelBySlug: function contactFieldLabelBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.label + (field.required === '1' ? '*' : '');
        },
        contactFieldRequiredBySlug: function contactFieldRequiredBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.required === '1';
        },
        contactFieldVisibleBySlug: function contactFieldVisibleBySlug(slug) {
            var field = _.find(this.contact.form_fields, { 'slug': slug });
            return field.visible === '1';
        },
        handleFormSubmit: function handleFormSubmit(evt) {
            console.info('handleFormSubmit', evt);

            vm.submitting = true;

            // gather the form contents
            var _form = $('#' + evt.target.id),
                _formContents = _form.serialize();

            // submit form data
            $.ajax({
                url: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].formSubmitApi,
                type: 'POST',
                data: _formContents,
                success: function success(res) {

                    console.info('The form was successfully submitted.', res);

                    gtag('event', 'Contact Form Submission', {
                        'event_category': 'MBRe: Residential',
                        'event_label': ''
                    });

                    // reset form input
                    _form[0].reset();

                    // re-enable submit buttons & kill sending msg
                    vm.submitting = true;

                    // set form submitted to true, will trigger thank you msg.
                    vm.submitted = true;
                },
                error: function error(xhr, status, err) {

                    console.error('There was an error submitting the form.', xhr, status, err);

                    // re-enable submit buttons & kill sending msg
                    vm.submitting = false;
                }
            });
        },
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-coverages',

    props: ['panel', 'slug', 'service', 'premise'],

    components: {},

    data: function data() {
        return {
            contact: {
                text: 'Ready to take the next step?',
                link: {
                    label: 'Contact us today'
                }
            }
        };
    },


    computed: {
        coverages: function coverages() {
            return this.$dataStore.getters.getCoverages;
        },
        addCoverageLabel: function addCoverageLabel() {
            return this.$dataStore.getters.getAdditionalCoveragesLabel;
        },
        serviceLineLabel: function serviceLineLabel() {
            return this.$dataStore.getters.getServiceLineCoverageLabel;
        },
        serviceLineLeadIn: function serviceLineLeadIn() {
            var _occupancies = this.$dataStore.getters.getOccupancies;
            return _occupancies.occupancy_service_line_lead_in;
        },
        serviceLineCoverages: function serviceLineCoverages() {
            var coverages = this.$dataStore.getters.getCoveragesByType('service-line');
            return _.sortBy(coverages, ['exposure_label']);
        },
        hasServiceLineCoverages: function hasServiceLineCoverages() {
            return this.$dataStore.getters.getServiceLineCoverages.length;
        },
        offPremiseLabel: function offPremiseLabel() {
            return this.$dataStore.getters.getOffPremiseCoverageLabel;
        },
        offPremiseLeadIn: function offPremiseLeadIn() {
            var _occupancies = this.$dataStore.getters.getOccupancies;
            return _occupancies.occupancy_off_premise_lead_in;
        },
        offPremiseCoverages: function offPremiseCoverages() {
            var coverages = this.$dataStore.getters.getCoveragesByType('off-premise');
            return _.sortBy(coverages, ['exposure_label']);
        },
        hasOffPremiseCoverages: function hasOffPremiseCoverages() {
            return this.$dataStore.getters.getOffPremisesCoverages.length;
        }
    },

    created: function created() {},
    mounted: function mounted() {

        vm = this;

        // scroll to tab & check it
        var _s = vm.slug,
            _checkEl = document.querySelectorAll('[data-coverage="' + _s + '"]')[0];

        if (typeof _checkEl !== 'undefined') {
            _checkEl.checked = true;
            vm.scrollToAnchor(vm.slug);
        }

        vm.playVideo();
        vm.initCarousel();
    },


    methods: {

        /**
         * @method playVideo
         * @description
         */
        playVideo: function playVideo() {
            var _video = $('.video-player-element');

            if (!_video.length) {
                return;
            }

            _.each(_video, function (val, key) {

                // video `canplay` event handler
                $(val).on('canplay', function () {
                    $(val).trigger('play');
                });

                // check `readyState` in case video element has already been init'd/cached
                if ($(val)[0].readyState > 3) {
                    $(val).trigger('play');
                }
            });
        },


        /**
         * @method initCarousel
         * @description
         */
        initCarousel: function initCarousel() {

            var _carousel = $('.image-carousel');

            if (!_carousel.length) {
                return;
            }

            vm.carousel = true;

            _.each(_carousel, function (val, key) {

                $(val).slick({
                    autoplay: true,
                    arrows: false,
                    pauseOnHover: false,
                    pauseOnFocus: false
                });
            });
        },


        /**
         * @method scrollToAnchor
         * @description
         */
        scrollToAnchor: function scrollToAnchor(slug) {

            var _anchorId = 'anchor_' + slug,
                _anchorEl = document.getElementById(_anchorId);

            var requestAnimFrame = function () {
                return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
            }();

            Math.easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) {
                    return c / 2 * t * t + b;
                }
                t--;
                return -c / 2 * (t * (t - 2) - 1) + b;
            };

            Math.easeInCubic = function (t, b, c, d) {
                var tc = (t /= d) * t * t;
                return b + c * tc;
            };

            Math.inOutQuintic = function (t, b, c, d) {
                var ts = (t /= d) * t,
                    tc = ts * t;
                return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
            };

            function isDomElement(obj) {
                return obj instanceof Element;
            }

            function scrollTo(to, callback) {
                var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1500;


                if (isDomElement(to)) {
                    to = to.offsetTop;
                }

                // because it's so fucking difficult to detect the scrolling element, just move them all
                function move(amount) {
                    document.documentElement.scrollTop = amount;
                    document.body.parentNode.scrollTop = amount;
                    document.body.scrollTop = amount;
                }

                function position() {
                    return document.documentElement.offsetTop || document.body.parentNode.offsetTop || document.body.offsetTop;
                }

                var start = position(),
                    change = to - start,
                    currentTime = 0,
                    increment = 20;

                var animateScroll = function animateScroll() {
                    // increment the time
                    currentTime += increment;
                    // find the value with the quadratic in-out easing function
                    var val = Math.easeInOutQuad(currentTime, start, change, duration);
                    // move the document.body
                    move(val);
                    // do the animation unless its over
                    if (currentTime < duration) {
                        requestAnimFrame(animateScroll);
                    } else {
                        if (callback && typeof callback === 'function') {
                            // the animation is done so lets callback
                            callback();
                        }
                    }
                };

                animateScroll();
            }

            scrollTo(_anchorEl);
        },


        /**
         * @method toggleCheck
         * @description
         * @param evt
         * @param slug
         */
        toggleCheck: function toggleCheck(evt, slug) {

            $('.image-carousel').slick('setPosition');

            var _checks = $('input[name="tabs-service[]"]');

            _.each(_checks, function (val) {
                if (evt.currentTarget.id !== $(val).attr('id')) {
                    $(val).prop('checked', false);
                }
            });

            vm.scrollToAnchor(slug);
        },


        /**
         * @method toggleOuterCheck
         * @description
         * @param evt
         * @param slug
         */
        toggleOuterCheck: function toggleOuterCheck(evt, slug) {

            $('.image-carousel').slick('setPosition');

            var _checks = $('input[name="outer-tabs[]"]');

            _.each(_checks, function (val) {
                if (evt.currentTarget.id !== $(val).attr('id')) {
                    $(val).prop('checked', false);
                }
            });

            vm.scrollToAnchor(slug);
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} type
         * @param {String} slug
         * @param {Object} evt
         * @param {Boolean} service
         * @param {Boolean} premise
         */
        togglePanel: function togglePanel(type, slug, evt, service, premise) {
            evt.stopPropagation();
            this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug, service: service, premise: premise });
            this.$eventBus.$emit('points:state:active', slug);
            this.$eventBus.$emit('residence:zoomto', { slug: slug });
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} type
         * @param {String} slug
         * @param {Object} evt
         * @param {Boolean} service
         * @param {Boolean} premise
         */
        togglePanel2: function togglePanel2(type, slug, evt, service, premise) {
            evt.stopPropagation();
            this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug, service: service, premise: premise });
        },
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        },


        /**
         * @method cssPropColor
         * @description
         * @param colorProp
         * @return {boolean}
         */
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        if (vm.carousel) {
            $('.image-carousel').slick('unslick');
        }
    }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-exposure',

    props: ['panel', 'slug', 'service', 'premise'],

    components: {},

    data: function data() {
        return {
            carousel: false,
            contact: {
                text: 'Ready to take the next step?',
                link: {
                    label: 'Contact us today'
                }
            }
        };
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getExposureBySlug(this.slug);
        },
        disclaimer: function disclaimer() {
            return this.$dataStore.getters.getExposureDisclaimer;
        },
        coverageContent: function coverageContent() {
            return this.$dataStore.getters.getCoverageContent;
        },
        labelOffPremise: function labelOffPremise() {
            return this.$dataStore.getters.getOffPremiseCoverageLabel;
        },
        labelServiceLine: function labelServiceLine() {
            return this.$dataStore.getters.getServiceLineCoverageLabel;
        },
        headerLabel: function headerLabel() {
            var _l = this.content.exposure_label,
                _s = this.content.exposure_slug,
                _c = this.content.coverage,
                _t = this.content.exposure_type;

            if (_s === 'laptop' && _t === 'off-premise' && _c) {
                return this.labelOffPremise + ': ' + _l;
            }

            return _l;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-exposure::created', 'color:dodgerblue;');

    },
    mounted: function mounted() {
        //console.info('%csidebar-content-exposure::mounted', 'color:green;');

        vm = this;

        // play video if we gotz one
        if (vm.content.media.type === 'video') {
            setTimeout(function () {
                vm.playVideo();
            }, 2000);
        }

        // init carousel if we gotz images
        if (vm.content.media.type === 'images') {
            setTimeout(function () {
                vm.initCarousel();
            }, 100);
        }
    },


    methods: {
        playVideo: function playVideo() {
            var _video = $('#video-player'),
                _videoEl = _video[0];

            // video `canplay` event handler
            _video.on('canplay', function () {
                _video.trigger('play');
            });

            // check `readyState` in case video element has already been init'd/cached
            if (_videoEl.readyState > 3) {
                _video.trigger('play');
            }
        },
        initCarousel: function initCarousel() {
            vm.carousel = true;
            $('.image-carousel').slick({
                autoplay: true,
                arrows: false,
                adaptiveHeight: true,
                pauseOnHover: false,
                pauseOnFocus: false
            });
        },
        trackEvent: function trackEvent(action, label) {
            gtag('event', action, {
                'event_category': 'MBRe: Residential',
                'event_label': label || ''
            });
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        },
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        }
    },

    events: {},

    beforeDestroy: function beforeDestroy() {
        if (vm.carousel) {
            $('.image-carousel').slick('unslick');
        }
    }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-about',

    props: ['title', 'panel'],

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getPowerSurgeData;
        },
        disclaimer: function disclaimer() {
            return this.$dataStore.getters.getExposureDisclaimer;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        isLast: function isLast(idx) {
            return idx === this.content.exposure.sections.length - 1;
        },
        backToHome: function backToHome() {
            //console.info('backToHome');
            this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
            this.$dataStore.dispatch('POWER_SURGE', { val: false });
            this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
            this.$eventBus.$emit('power-surge:end');
            this.$dataStore.dispatch('PANEL_OPEN', { val: false });
            this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });
            // show points
            this.$eventBus.$emit('points:show');
        },
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-privacy',

    props: ['panel'],

    components: {},

    data: function data() {
        return {
            title: 'Privacy Policy'
        };
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getPrivacyData;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'panel-content-terms',

    props: ['panel'],

    components: {},

    data: function data() {
        return {
            title: 'Terms and Conditions'
        };
    },


    computed: {
        content: function content() {
            return this.$dataStore.getters.getTermsData;
        }
    },

    created: function created() {
        //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
    },
    mounted: function mounted() {
        //console.info('%csidebar-content-privacy::mounted', 'color:green;');

        vm = this;
    },


    methods: {
        closePanel: function closePanel(evt) {
            vm.$eventBus.$emit('residence:zoomout');
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    },

    events: {}

});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'power-surge-button',

    components: {},

    data: function data() {
        return {
            icon: 'icon-MBR_power-surge',
            label: 'Power Surge',
            display: true
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.state.interactive.entered;
        },
        hasPowerSurge: function hasPowerSurge() {
            return this.$dataStore.getters.getPowerSurge.length;
        },
        powerSurge: function powerSurge() {
            return this.$dataStore.state.interactive.powerSurge;
        },
        powerSurgeOverlayState: function powerSurgeOverlayState() {
            return this.$dataStore.getters.getPowerSurgeOverlayState;
        }
    },

    created: function created() {
        //console.info('%cPowerSurgeButton::created', 'color:dodgerblue;');

        vm = this;

        this.$eventBus.$on('powersurge:complete', vm.completePowerSurge);
    },
    mounted: function mounted() {
        //console.info('%cPowerSurgeButton::mounted', 'color:green;');

        vm = this;
    },


    methods: {

        /**
         * @method lightsOut
         * @description
         */
        lightsOut: function lightsOut() {

            gtag('event', 'Power Surge Button', {
                'event_category': 'MBRe: Residential',
                'event_label': ''
            });

            // zoom out
            this.$eventBus.$emit('residence:zoomout', 1.2);
            // close any active panels
            this.$dataStore.dispatch('PANEL_OPEN', { val: false });
            this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });
            // kickoff power surge
            this.$dataStore.dispatch('POWER_SURGE', { val: true });
            this.$dataStore.dispatch('POWER_SURGE_STATE', { val: true });
            this.$eventBus.$emit('power-surge:start');
            // hide points
            this.$eventBus.$emit('points:hide');

            setTimeout(function () {
                vm.playPowerSurgeAnimations();
            }, 1700);
        },
        playPowerSurgeAnimations: function playPowerSurgeAnimations() {

            var powerSurgeAnimations = this.$dataStore.getters.getPowerSurgeAnimations;

            var sortedArr = _.orderBy(powerSurgeAnimations, function (o) {
                return o.animation.powerGridOrder;
            }, ['asc']);

            _.each(sortedArr, function (val, key) {

                if (key === sortedArr.length - 1) {
                    vm.$dataStore.dispatch('LAST_EXPOSURE_ANIMATION', { val: val.exposure_slug });
                }

                setTimeout(function () {
                    vm.$eventBus.$emit('exposure:animate', val.exposure_slug);
                }, 400 * key);
            });
        },
        completePowerSurge: function completePowerSurge() {
            vm.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: true });

            setTimeout(function () {
                // toggle panel
                vm.togglePanel('panel-content-power-surge');
            }, 800);
        },


        /**
         * @method show
         * @description
         */
        show: function show() {
            this.display = true;
        },


        /**
         * @method hide
         * @description
         */
        hide: function hide() {
            this.display = false;
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} type
         */
        togglePanel: function togglePanel(type) {
            this.$eventBus.$emit('panel:toggle', { panel: type });
        }
    }

});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'power-surge-overlay',

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        powerSurgeOverlay: function powerSurgeOverlay() {
            return this.$dataStore.state.interactive.powerSurgeOverlay;
        }
    },

    watch: {
        powerSurge: function powerSurge(nVal, oVal) {
            // add/kill event listener
            if (nVal) {
                document.addEventListener('keyup', vm.handleKeys, false);
            } else {
                document.removeEventListener('keyup', vm.handleKeys, false);
            }
        }
    },

    created: function created() {
        vm = this;
    },
    mounted: function mounted() {
        vm = this;
    },


    methods: {

        /**
         * @method handleKeys
         * @description
         * @param {Object} evt
         */
        handleKeys: function handleKeys(evt) {

            switch (evt.keyCode) {
                case 27:
                    // ESC
                    this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE', { val: false });
                    this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                    this.$eventBus.$emit('power-surge:end');
                    this.$dataStore.dispatch('PANEL_OPEN', { val: false });
                    this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });
                    break;
            }
        }
    }

});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'progress-button',

    props: ['loadingLabel', 'readyLabel', 'method'],

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        loaded: function loaded() {
            return this.$dataStore.getters.getLoadedState;
        },
        buttonLabel: function buttonLabel() {
            return this.loaded ? this.readyLabel : this.loadingLabel;
        }
    },

    created: function created() {
        this.$eventBus.$on('loading:ready', this.setReady);
    },
    mounted: function mounted() {
        vm = this;
    },


    methods: {
        handleClick: function handleClick() {
            if (vm.$md.phone()) {
                this.method();
            }
        },
        setReady: function setReady() {
            vm.$dataStore.dispatch('LOADED', { val: true });
        },
        cssPropColor: function cssPropColor(colorProp) {
            if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                return;
            } else {
                return window.appTheme.colors[colorProp] ? window.appTheme.colors[colorProp] : false;
            }
        }
    }

});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pixi_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pixi_layers__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pixi_layers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pixi_layers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pixi_filters__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hammerjs__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hammerjs__);

//
//
//
//
//
//
//
//
//
//
//








var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'residence-interactive',

    components: {},

    data: function data() {
        return {
            zoomed: false,
            residenceImage: '/static/images/MBR-055_House-Layered_Base_75.jpg',
            target: {
                width: 5933,
                height: 3671
            },
            pixiApp: null,
            container: null,
            stage: null,
            residence: null,
            pointLayer: null,
            graphicLayer: null,
            animationLayer: null,
            highlightLayer: null,
            dimLayer: null,
            scale: {
                initial: 0.4,
                wide: 0.25,
                min: 0.31,
                max: 1,
                duration: {
                    in: 1.3,
                    out: 1.3
                },
                points: {
                    in: 1,
                    out: 1
                }
            },
            zoomInOffset: {
                x: 500,
                y: 500
            },
            rooms: [{
                name: 'bedroom',
                width: 939,
                height: 530,
                x: -730,
                y: -92
            }, {
                name: 'landing',
                width: 835,
                height: 530,
                x: 186,
                y: -92
            }, {
                name: 'bathroom',
                width: 832,
                height: 530,
                x: 1047,
                y: -92
            }, {
                name: 'livingroom',
                width: 1372,
                height: 530,
                x: -709,
                y: 494
            }, {
                name: 'kitchen',
                width: 969,
                height: 530,
                x: 489,
                y: 494
            }, {
                name: 'mudroom',
                width: 462,
                height: 530,
                x: 1232,
                y: 494
            }],
            exposureObjects: {},
            exposureImageObjects: {},
            animationObjects: {},
            highlightObjects: [],
            dimmerObjects: [],
            lastInteraction: 0,
            pulseTimeline: [],
            pulseInterval: null,
            pulseTimeout: null,
            pulseIntervalDuration: 3000,
            pulseAll: true,
            pulseAnimating: false,
            pulseClicked: false
        };
    },


    computed: {
        hasEntered: function hasEntered() {
            return this.$dataStore.getters.getEnteredState;
        },
        isZoomed: function isZoomed() {
            return this.$dataStore.getters.getZoomedState;
        },
        pApp: function pApp() {
            return this.$dataStore.getters.getInteractive;
        },
        exposures: function exposures() {
            return this.$dataStore.getters.getExposures;
        },
        powerSurge: function powerSurge() {
            return this.$dataStore.getters.getExposures;
        }
    },

    created: function created() {
        vm = this;

        this.$eventBus.$on('residence:zoomin', vm.zoomIn);
        this.$eventBus.$on('residence:zoomout', function (duration) {
            return vm.zoomOut(duration);
        });
        this.$eventBus.$on('residence:zoomto', function (obj) {
            vm.zoomTo(1, 1, 1, Quad.easeInOut, null, vm.exposureObjects[obj.slug]);
        });
        this.$eventBus.$on('residence:transition:in', vm.transitionIn);
        this.$eventBus.$on('residence:resize', function (_d) {
            setTimeout(function () {
                _d = typeof _d !== 'undefined' ? _d : 600;vm.resizeResidence();
            }, _d);
        });
        this.$eventBus.$on('exposure:animate', function (name) {
            return vm.playExposureAnimation(name);
        });
        this.$eventBus.$on('power-surge:dimmer', vm.animateDimmers);
        this.$eventBus.$on('power-surge:end', vm.resetExposureAnimations);
        this.$eventBus.$on('points:show', vm.showPoints);
        this.$eventBus.$on('points:hide', vm.hidePoints);
        this.$eventBus.$on('points:state:reset', vm.resetPointsState);
        this.$eventBus.$on('points:state:active', function (point) {
            return vm.setPointState(point);
        });
    },
    mounted: function mounted() {
        vm = this;

        if (vm.$md.tablet()) {
            vm.residenceImage = '/static/images/MBR-055_House-Layered_Base_tablet.jpg';
            vm.scale.points.out = 2.5;
            vm.scale.wide = .20;
            vm.scale.min = .25;
        }

        vm.debug = vm.getQueryString("debug") == 1;
        vm.createResidence();

        addResizeListener(document.getElementById('base-container'), function () {
            vm.resizeResidence();
        });
    },


    methods: {
        getQueryString: function getQueryString(key, default_) {
            if (default_ == null) {
                default_ = "";
            }
            key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
            var qs = regex.exec(window.location.href);
            if (qs == null) {
                return default_;
            } else {
                return qs[1];
            }
        },


        /**
         * @method createResidence
         * @description Create PIXI Application Scene.
         */
        createResidence: function createResidence() {

            var _container = document.getElementById('base-container'),
                _width = _container.clientWidth,
                _height = _container.clientHeight,
                _forceCanvas = !!vm.$md.tablet();

            // override the width & height on tablet, due to clientHeight not being available in time on older devices
            if (vm.$md.tablet()) {
                if (typeof document.compatMode == 'undefined' || document.compatMode == 'CSS1Compat') {
                    _width = document.documentElement.clientWidth;
                    _height = document.documentElement.clientHeight - document.querySelector('footer').clientHeight;
                }
            }

            vm.pixiApp = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Application"]({
                width: _width,
                height: _height,
                transparent: false,
                antialias: true,
                resolution: 1,
                forceCanvas: _forceCanvas,
                autoResize: true,
                roundPixels: true,
                legacy: true
            });

            vm.pixiApp.renderer.backgroundColor = 0xCBCBCB;

            window.pixiApp = vm.pixiApp;

            _container.appendChild(vm.pixiApp.view);

            vm.graphicLayer = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Group(5, true);
            vm.animationLayer = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Group(10, true);
            vm.highlightLayer = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Group(15, true);
            vm.dimLayer = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Group(19, true);
            vm.pointLayer = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Group(20, true);

            vm.pixiApp.stage = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Stage();
            vm.pixiApp.stage.group.enableSort = true;
            vm.pixiApp.stage._name = 'stage';

            vm.pixiApp.stage.addChild(new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Layer(vm.graphicLayer));
            vm.pixiApp.stage.addChild(new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Layer(vm.animationLayer));
            vm.pixiApp.stage.addChild(new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Layer(vm.highlightLayer));
            vm.pixiApp.stage.addChild(new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Layer(vm.dimLayer));
            vm.pixiApp.stage.addChild(new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["display"].Layer(vm.pointLayer));

            vm.offset = { x: 0, y: 0 }; //{x:77, y:91}
            vm.pointsOffset = { x: 0, y: 0 };

            __WEBPACK_IMPORTED_MODULE_1_pixi_js__["settings"].SCALE_MODE = __WEBPACK_IMPORTED_MODULE_1_pixi_js__["SCALE_MODES"].LINEAR;

            vm.pixiApp.renderer.render(vm.pixiApp.stage);

            __WEBPACK_IMPORTED_MODULE_1_pixi_js__["loader"].add('_residence', vm.residenceImage).load(setup);

            function setup() {
                var _container = document.getElementById('base-container'),
                    _width = _container.clientWidth,
                    _height = _container.clientHeight;

                // vm.residence = new PIXI.Sprite(PIXI.loader.resources['_residence'].texture);
                var origTex = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["RenderTexture"].create(vm.target.width, vm.target.height);
                vm.residence = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Sprite"](origTex);
                vm.residence._name = 'residence';
                vm.residence.alpha = 0;
                vm.residence.interactive = true;
                vm.residence.buttonMode = true;
                vm.residence.cursor = 'move';
                vm.residence.scale.x = vm.scale.initial;
                vm.residence.scale.y = vm.scale.initial;
                vm.residence.anchor.x = 0.5;
                vm.residence.anchor.y = 0.5;
                vm.residence.x = _width * .5;
                vm.residence.y = _height * .5;
                vm.residence.zOrder = 1;

                vm.residence.on('pointerdown', onDragStart).on('pointerup', onDragEnd).on('pointerupoutside', onDragEnd).on('pointermove', onDragMove);

                // add the house texture to an inner sprite, so we can scale it independently
                vm.residenceInner = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Sprite"](__WEBPACK_IMPORTED_MODULE_1_pixi_js__["loader"].resources['_residence'].texture);
                vm.residenceInner.anchor.x = 0.5;
                vm.residenceInner.anchor.y = 0.5;
                vm.residenceInner.width = 5933;
                vm.residenceInner.height = 3671;
                vm.residence.addChild(vm.residenceInner);

                vm.pixiApp.stage.addChild(vm.residence);

                __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.residence, 1.2, {
                    alpha: 1,
                    ease: Quad.easeInOut
                });

                vm.addExposureImages();

                vm.pixiApp.ticker.add(update);

                // vm.hammer = new Hammer(_container);
                // vm.hammer.get('pinch').set({ enable: true });

                if (vm.$md.tablet()) {
                    vm.hammerManager = new __WEBPACK_IMPORTED_MODULE_5_hammerjs___default.a.Manager(_container);
                    vm.hammerManager.add(new __WEBPACK_IMPORTED_MODULE_5_hammerjs___default.a.Pinch());
                    vm.hammerManager.on("pinchout", onPinchIn);
                    vm.hammerManager.on("pinchin", onPinchOut);
                    vm.isPinching = false;
                }
            }

            function onPinchIn(evt) {
                if (vm.isPinching) return;

                vm.isPinching = true;
                setTimeout(function () {
                    vm.isPinching = false;
                }, 1500);

                // vm.zoomIn();
                vm.$eventBus.$emit('residence:zoomin');
            }

            function onPinchOut(evt) {
                if (vm.isPinching) return;

                vm.isPinching = true;
                setTimeout(function () {
                    vm.isPinching = false;
                }, 1500);

                // vm.zoomOut();
                vm.$eventBus.$emit('residence:zoomout');
                vm.$eventBus.$emit('panel:close');
            }

            /**
             * Update loop
             */
            function update() {

                var _container = document.getElementById('base-container'),
                    _width = _container.clientWidth,
                    _height = _container.clientHeight;

                // keep everything in bounds
                if (vm.residence.getBounds().width < _width) {
                    __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].killTweensOf(vm.residence, { x: true, y: true });
                    vm.residence.width = _width;
                    vm.residence.scale.y = vm.residence.width / vm.residence.getLocalBounds().width;
                    vm.residence.x = _width * .5;
                } else if (vm.residence.getBounds().height < _height) {
                    __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].killTweensOf(vm.residence, { x: true, y: true });
                    vm.residence.height = _height;
                    vm.residence.scale.x = vm.residence.height / vm.residence.getLocalBounds().height;
                    vm.residence.y = _height * .5;
                }

                // moved rimJob code here so we are doing all constraining in one place
                var _minX = vm.residence.width / 2,
                    _minY = vm.residence.height / 2 - vm.offset.y,
                    _maxX = vm.pixiApp.renderer.width - vm.residence.width / 2 - vm.offset.x,
                    _maxY = vm.pixiApp.renderer.height - vm.residence.height / 2;

                vm.residence.position.x = vm.clamp(vm.residence.position.x, _minX, _maxX);
                vm.residence.position.y = vm.clamp(vm.residence.position.y, _minY, _maxY);
            }

            function onDragStart(evt) {
                this.data = evt.data;
                this.dragging = this.data.getLocalPosition(this.parent);
                // interrupt pulse animations
                vm.lastInteraction = vm.timeStampMs();
            }

            function onDragEnd() {
                this.dragging = false;
                this.data = null;
                // interrupt pulse animations
                vm.lastInteraction = vm.timeStampMs();
            }

            function onDragMove() {
                if (this.dragging) {
                    var newPos = this.data.getLocalPosition(this.parent);

                    this.position.x += newPos.x - this.dragging.x;
                    this.position.y += newPos.y - this.dragging.y;

                    var _minX = vm.residence.width / 2,
                        _minY = vm.residence.height / 2 - vm.offset.y,
                        _maxX = vm.pixiApp.renderer.width - vm.residence.width / 2 + vm.offset.x,
                        _maxY = vm.pixiApp.renderer.height - vm.residence.height / 2;

                    this.position.x = vm.clamp(this.position.x, _minX, _maxX);
                    this.position.y = vm.clamp(this.position.y, _minY, _maxY);

                    this.dragging = newPos;

                    // interrupt pulse animations
                    vm.lastInteraction = vm.timeStampMs();
                }
            }

            var debouncedResize = _.debounce(vm.resizeResidence, 30);
            window.addEventListener('resize', debouncedResize, false);
            window.addEventListener('deviceOrientation', debouncedResize, false);

            vm.resizeResidence();
        },


        /**
         * @method createExposurePoints
         * @description
         */
        createExposurePoints: function createExposurePoints() {

            var _primaryColor = vm.getCSSColorVariable('--color-primary-rgb'),
                _secondaryColor = vm.getCSSColorVariable('--color-secondary-rgb');

            _primaryColor = _primaryColor.split("(")[1].split(")")[0];
            _secondaryColor = _secondaryColor.split("(")[1].split(")")[0];

            _primaryColor = _primaryColor.split(',');
            _secondaryColor = _secondaryColor.split(',');

            var _primaryColorX = _primaryColor.map(function (x) {
                x = parseInt(x).toString(16);
                return x.length == 1 ? '0' + x : x;
            });
            _primaryColorX = '0x' + _primaryColorX.join('');

            var _secondaryColorX = _secondaryColor.map(function (x) {
                x = parseInt(x).toString(16);
                return x.length == 1 ? '0' + x : x;
            });
            _secondaryColorX = '0x' + _secondaryColorX.join('');

            //console.log('_primaryColorX', _primaryColorX);
            //console.log('_secondaryColorX', _secondaryColorX);

            var _d = vm.$md.tablet() ? 8 : 16,
                _rd = vm.$md.tablet() ? 2 : 4;

            // circles
            var _circleUp = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Graphics"]();
            _circleUp.beginFill(0xFFFFFF);
            _circleUp.lineStyle(_rd, _primaryColorX);
            _circleUp.drawCircle(_d, _d, _d);
            _circleUp.endFill();

            var _circleUpTexture = _circleUp.generateCanvasTexture();

            var _circleOver = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Graphics"]();
            _circleOver.beginFill(0xFFFFFF);
            _circleOver.lineStyle(_rd, _secondaryColorX);
            _circleOver.drawCircle(_d, _d, _d);
            _circleOver.endFill();

            var _circleOverTexture = _circleOver.generateCanvasTexture();

            // dropshadow filter
            var _shadow = new __WEBPACK_IMPORTED_MODULE_3_pixi_filters__["a" /* DropShadowFilter */]();
            _shadow.blur = 5;
            _shadow.alpha = 0.36;
            _shadow.distance = 0;

            var _zoomed = this.$dataStore.getters.getZoomedState;

            // loop through all exposures and place circle
            _.each(vm.exposures, function (val, key) {

                var _s = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Sprite"](_circleUpTexture);

                _s._data = val;
                _s._interacted = false;
                _s._name = val.exposure_name;
                _s._slug = val.exposure_slug;
                _s._active = false;
                _s.interactive = true;
                _s.buttonMode = true;
                _s.cursor = 'pointer';
                _s.alpha = 0;
                _s.zOrder = 999;
                _s.position.x = val.x + vm.pointsOffset.x;
                _s.position.y = val.y + vm.pointsOffset.y;
                _s.scale.x = 1;
                _s.scale.y = 1;
                _s.anchor.x = 0.5;
                _s.anchor.y = 0.5;
                _s.parentGroup = vm.pointLayer;

                // add shadows to exposurepPoints if using WEBGL and not tablet
                if (__WEBPACK_IMPORTED_MODULE_1_pixi_js__["RENDERER_TYPE"].WEBGL == vm.pixiApp.renderer.type && !vm.$md.tablet()) {
                    _s.filters = [_shadow]; /* WebGL only... */
                }

                _s.on('pointerup', function (evt) {

                    var _this = this,

                    /*_panel  = (_this._data.coverage) ? 'panel-content-coverages' : 'panel-content-exposure',*/
                    _panel = 'panel-content-exposure',
                        _service = _this._data.exposure_type === 'service-line',
                        _premise = _this._data.exposure_type === 'off-premise';

                    gtag('event', 'Equipment Selection', {
                        'event_category': 'MBRe: Residential',
                        'event_label': _this._name
                    });

                    // set interacted flag
                    _this._interacted = true;
                    vm.pulseClicked = true;

                    // reset/set active states
                    vm.resetPointsState();

                    setTimeout(function () {
                        _this._active = true;
                        _this.texture = _circleOverTexture;
                    }, 10);

                    // toggle panel
                    vm.togglePanel(_panel, _this._slug, _service, _premise);

                    // zoom to point
                    vm.zoomTo(1, 1, 1, Quad.easeInOut, evt, _this);

                    if (vm.debug) {
                        setTimeout(function () {
                            vm.playExposureAnimation(_this._slug);
                        }, 1000);
                    }
                });

                _s.on('pointerover', function (evt) {
                    var _this = this;
                    _this.texture = _circleOverTexture;
                });

                _s.on('pointerout', function (evt) {
                    var _this = this;
                    if (_this._active) {
                        _this.texture = _circleOverTexture;
                    } else {
                        _this.texture = _circleUpTexture;
                    }
                });

                vm.residence.addChild(_s);

                vm.exposureObjects[val.exposure_slug] = _s;

                if (val.enabled && val.animation.enabled) {
                    // name, json, frame, x, y
                    vm.createExposureAnimations(val.exposure_slug, val.animation.json, val.animation.name, val.animation.x, val.animation.y, val.animation.frames, val.animation.loop);
                }
            });

            // emit ready
            vm.$eventBus.$emit('loading:ready');
        },


        /**
         * @method showPoints
         * @description
         */
        showPoints: function showPoints() {

            _.each(vm.exposureObjects, function (val) {
                __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(val, 0.2, { alpha: 1 });
            });

            vm.startPulseAnimations();
        },


        /**
         * @method hidePoints
         * @description
         */
        hidePoints: function hidePoints() {

            vm.stopPulseAnimations();

            __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].set(vm.highlightObjects, { alpha: 0 });

            _.each(vm.exposureObjects, function (val) {
                __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(val, 0.2, { alpha: 0 });
            });
        },
        setPointState: function setPointState(point) {
            console.log('setPointState', point);
            var _primaryColor = vm.getCSSColorVariable('--color-primary-rgb'),
                _secondaryColor = vm.getCSSColorVariable('--color-secondary-rgb');

            _primaryColor = _primaryColor.split("(")[1].split(")")[0];
            _secondaryColor = _secondaryColor.split("(")[1].split(")")[0];

            _primaryColor = _primaryColor.split(',');
            _secondaryColor = _secondaryColor.split(',');

            var _primaryColorX = _primaryColor.map(function (x) {
                x = parseInt(x).toString(16);
                return x.length == 1 ? '0' + x : x;
            });
            _primaryColorX = '0x' + _primaryColorX.join('');

            var _secondaryColorX = _secondaryColor.map(function (x) {
                x = parseInt(x).toString(16);
                return x.length == 1 ? '0' + x : x;
            });
            _secondaryColorX = '0x' + _secondaryColorX.join('');

            console.log('_primaryColorX', _primaryColorX);
            console.log('_secondaryColorX', _secondaryColorX);

            var _d = vm.$md.tablet() ? 8 : 16,
                _rd = vm.$md.tablet() ? 2 : 4;

            var _circleOver = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Graphics"]();
            _circleOver.beginFill(0xFFFFFF);
            _circleOver.lineStyle(_rd, _secondaryColorX);
            _circleOver.drawCircle(_d, _d, _d);
            _circleOver.endFill();

            var _circleOverTexture = _circleOver.generateCanvasTexture();

            vm.exposureObjects[point]._active = true;
            vm.exposureObjects[point].texture = _circleOverTexture;
        },


        /**
         * @method resetPointsState
         * @description
         */
        resetPointsState: function resetPointsState() {

            var _primaryColor = vm.getCSSColorVariable('--color-primary-rgb'),
                _secondaryColor = vm.getCSSColorVariable('--color-secondary-rgb');

            _primaryColor = _primaryColor.split("(")[1].split(")")[0];
            _secondaryColor = _secondaryColor.split("(")[1].split(")")[0];

            _primaryColor = _primaryColor.split(',');
            _secondaryColor = _secondaryColor.split(',');

            var _primaryColorX = _primaryColor.map(function (x) {
                x = parseInt(x).toString(16);
                return x.length == 1 ? '0' + x : x;
            });
            _primaryColorX = '0x' + _primaryColorX.join('');

            var _secondaryColorX = _secondaryColor.map(function (x) {
                x = parseInt(x).toString(16);
                return x.length == 1 ? '0' + x : x;
            });
            _secondaryColorX = '0x' + _secondaryColorX.join('');

            console.log('_primaryColorX', _primaryColorX);
            console.log('_secondaryColorX', _secondaryColorX);

            var _d = vm.$md.tablet() ? 8 : 16,
                _rd = vm.$md.tablet() ? 2 : 4;

            var _circleUp = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Graphics"]();
            _circleUp.nativeLines = true;
            _circleUp.beginFill(0xFFFFFF);
            _circleUp.lineStyle(_rd, _primaryColorX);
            _circleUp.drawCircle(_d, _d, _d);
            _circleUp.endFill();

            var _circleUpTexture = _circleUp.generateCanvasTexture();

            _.each(vm.exposureObjects, function (val) {
                val._active = false;
                val.texture = _circleUpTexture;
            });
        },


        /**
         * @method scaleExposurePoints
         * @description
         */
        scaleExposurePoints: function scaleExposurePoints() {

            var _zoomed = this.$dataStore.getters.getZoomedState;

            _.each(vm.exposureObjects, function (val, key) {
                var tl = new TimelineMax({
                    onUpdateScope: vm.pixiApp.stage
                });

                tl.to(val.scale, 0.3, {
                    x: _zoomed ? vm.scale.points.in : vm.scale.points.out,
                    y: _zoomed ? vm.scale.points.in : vm.scale.points.out,
                    ease: Quad.easeInOut
                });
            });
        },


        /**
         * @method animateExposurePoints
         * @description
         */
        animateExposurePoints: function animateExposurePoints() {

            var _x = 0,
                _zoomed = this.$dataStore.getters.getZoomedState;

            _.each(vm.exposureObjects, function (val, key) {

                var tl = new TimelineMax({
                    onCompleteParams: [_x],
                    onComplete: function onComplete(_key) {
                        if (_key >= __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(vm.exposureObjects).length - 1) {
                            // interactive transition is complete
                            vm.$dataStore.dispatch('TRANSITION_INTERACTIVE', { val: true });

                            if (!vm.$dataStore.getters.getPowerSurgeState) {
                                // points are now in, show interaction cta
                                vm.$eventBus.$emit('cta:show');
                            }

                            vm.createExposurePointPulse();
                        }
                    }
                });

                tl.to(val, 0.3, {
                    alpha: vm.$dataStore.getters.getPowerSurgeState ? 0 : 1,
                    ease: Back.easeOut
                }, '-=0.3');

                tl.to(val.scale, 0.6, {
                    x: _zoomed ? vm.scale.points.in : vm.scale.points.out,
                    y: _zoomed ? vm.scale.points.in : vm.scale.points.out,
                    ease: Back.easeOut
                });

                _x++;
            });
        },


        /**
         * @method createExposurePointPulse
         * @description
         */
        createExposurePointPulse: function createExposurePointPulse() {

            var _d = vm.$md.tablet() ? 8 : 16;

            // circles
            var _pulse = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Graphics"]();
            _pulse.nativeLines = true;
            _pulse.beginFill(0xFFFFFF);
            _pulse.lineStyle(0, 0xFFFFFF);
            _pulse.drawCircle(_d, _d, _d);
            _pulse.endFill();

            var _pulseTexture = _pulse.generateCanvasTexture();

            // loop through all exposures and place circle
            _.each(vm.exposures, function (val, key) {

                var _p = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Sprite"](_pulseTexture);

                _p._name = 'pulse_' + val.exposure_slug;
                _p._slug = val.exposure_slug;
                _p.interactive = false;
                _p.buttonMode = false;
                _p.alpha = 0;
                _p.zOrder = 1000;
                _p.position.x = val.x + vm.pointsOffset.x;
                _p.position.y = val.y + vm.pointsOffset.y;
                _p.scale.x = 1;
                _p.scale.y = 1;
                _p.anchor.x = 0.5;
                _p.anchor.y = 0.5;
                _p.parentGroup = vm.highlightLayer;

                vm.residence.addChild(_p);

                vm.highlightObjects.push(_p);
            });

            setTimeout(function () {
                vm.startPulseAnimations();
            }, vm.pulseIntervalDuration);
        },


        /**
         * @method animateExposurePointPulse
         * @description
         */
        animateExposurePointPulse: function animateExposurePointPulse() {

            if (this.$dataStore.getters.getPowerSurgeState) {
                vm.pulseAnimating = false;
                return;
            }

            vm.pulseAnimating = true;

            if (vm.pulseAll) {

                // ALL AT ONCE
                _.each(vm.highlightObjects, function (val, key) {

                    if (!vm.pulseClicked) {

                        vm.pulseTimeline[key] = new TimelineMax({ repeat: -1 });

                        vm.pulseTimeline[key].set(val, {
                            alpha: 1
                        });

                        vm.pulseTimeline[key].set(val.scale, {
                            x: 1,
                            y: 1
                        });

                        vm.pulseTimeline[key].to(val.scale, 1.2, {
                            x: 2,
                            y: 2,
                            ease: Quad.easeInOut,
                            delay: 0.02 * key
                        });

                        vm.pulseTimeline[key].to(val, 1.2, {
                            alpha: 0,
                            ease: Quad.easeInOut
                        }, '-=0.8');
                    }
                });
            } else {

                // RANDOM ONE AT A TIME
                var _count = vm.highlightObjects.length,
                    _randPoint = vm.highlightObjects[_.random(0, _count - 1)];

                if (!vm.pulseClicked) {

                    vm.pulseTimeline[0] = new TimelineMax({ repeat: 8, repeatDelay: 0.2 });

                    vm.pulseTimeline[0].set(_randPoint, {
                        alpha: 1
                    });

                    vm.pulseTimeline[0].set(_randPoint.scale, {
                        x: 1,
                        y: 1
                    });

                    vm.pulseTimeline[0].to(_randPoint.scale, 1.2, {
                        x: 1.8,
                        y: 1.8,
                        ease: Quad.easeInOut,
                        delay: 0.3
                    });

                    vm.pulseTimeline[0].to(_randPoint, 1.2, {
                        alpha: 0,
                        ease: Quad.easeInOut
                    }, '-=0.8');
                }
            }
        },


        /**
         * @method startPulseAnimations
         * @description
         */
        startPulseAnimations: function startPulseAnimations() {

            // check if we've clicked a point, if so kill
            if (vm.pulseClicked) {
                if (vm.pulseAnimating) {
                    vm.stopPulseAnimations();
                }
                if (vm.pulseInterval) {
                    clearInterval(vm.pulseInterval);
                }
                return;
            }

            vm.pulseInterval = setInterval(function () {

                if (vm.lastInteraction <= vm.timeStampMs() - vm.pulseIntervalDuration) {
                    if (!vm.pulseAnimating && vm.pulseAll || !vm.pulseAll) {
                        vm.animateExposurePointPulse();
                    }
                } else {
                    vm.stopPulseAnimations();
                }
            }, vm.pulseIntervalDuration);
        },


        /**
         * @method stopPulseAnimations
         * @description
         */
        stopPulseAnimations: function stopPulseAnimations() {

            vm.pulseAnimating = false;

            if (vm.pulseAll) {
                _.each(vm.pulseTimeline, function (val, key) {
                    if (!val) {
                        return;
                    }
                    val.seek(0).stop();
                });
            } else {
                vm.pulseTimeline[0].stop();
            }

            vm.pulseTimeline = [];
        },


        /**
         * @method addExposureImages
         * @description
         */
        addExposureImages: function addExposureImages() {

            _.each(vm.exposures, function (val, key) {

                if (val.enabled === false || val.graphic === null) {
                    return;
                }

                var _name = val.exposure_slug + '_exposure';

                if (_.isNil(vm.exposureImageObjects[_name])) {
                    __WEBPACK_IMPORTED_MODULE_1_pixi_js__["settings"].SCALE_MODE = __WEBPACK_IMPORTED_MODULE_1_pixi_js__["SCALE_MODES"].LINEAR;
                    // texture does not exist, load it up
                    var _loader = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["loaders"].Loader();
                    _loader.add(_name, val.graphic.source).load(onExposureLoaded);
                }

                function onExposureLoaded(loader, resources) {

                    var _ex = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Sprite"](resources[_name].texture);

                    _ex._name = _name;
                    _ex.interactive = false;
                    _ex.buttonMode = false;
                    _ex.alpha = 1;
                    _ex.anchor.x = 0;
                    _ex.anchor.y = 0;
                    _ex.x = val.graphic.x + vm.pointsOffset.x;
                    _ex.y = val.graphic.y + vm.pointsOffset.y;
                    _ex.parentGroup = vm.graphicLayer;

                    vm.residence.addChild(_ex);

                    vm.exposureImageObjects[_name] = _ex;
                }
            });

            vm.createExposurePoints();
            vm.createRoomDimmers();
        },
        debugExposureImages: function debugExposureImages() {
            //console.log("debugExposureImages");

            // animationObjects
            _.each(vm.animationObjects, function (item, key) {

                item.interactive = true;
                item.on('pointerdown', function (event) {
                    window.moveItem = item;
                });
            });

            // exposureObjects
            _.each(vm.exposureObjects, function (item, key) {

                item.interactive = true;
                item.on('pointerdown', function (event) {
                    window.moveItem = item;
                });
            });

            // exposureImageObjects
            _.each(vm.exposureImageObjects, function (item, key) {
                item.interactive = true;
                item.on('pointerdown', function (event) {
                    window.moveItem = item;
                });
            });

            document.addEventListener('keydown', function (key) {

                var moveAmount = 1;
                var isShift = !!key.shiftKey;

                if (isShift) {
                    moveAmount = 10;
                }

                switch (key.keyCode) {
                    // UP
                    case 38:
                        window.moveItem.y -= moveAmount;
                        break;

                    // DOWN
                    case 40:
                        window.moveItem.y += moveAmount;
                        break;

                    // LEFT
                    case 37:
                        window.moveItem.x -= moveAmount;
                        break;

                    // RIGHT
                    case 39:
                        window.moveItem.x += moveAmount;
                        break;
                }
                //console.log('"x": ' + window.moveItem.x + ', ' + '"y": ' + window.moveItem.y + ',');
            });
        },


        /**
         * @method createExposureAnimations
         * @description
         * @param {String} name
         * @param {String} json
         * @param {String} frame
         * @param {Number} x
         * @param {Number} y
         * @param {Number} frames
         * @param {Boolean} loop
         */
        createExposureAnimations: function createExposureAnimations(name, json, frame, x, y, frames, loop) {
            //console.log('createExposureAnimations', name, json, frame, x, y, frames, loop);

            if (_.isNil(vm.animationObjects[name])) {
                __WEBPACK_IMPORTED_MODULE_1_pixi_js__["settings"].SCALE_MODE = __WEBPACK_IMPORTED_MODULE_1_pixi_js__["SCALE_MODES"].LINEAR;
                // texture does not exist, load it up
                var _loader = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["loaders"].Loader();
                _loader.add(name, json).load(onAnimationLoaded);
            } else {
                // texture exists, play dat ish
                vm.animationObjects[name].gotoAndPlay(1);
            }

            function onAnimationLoaded(loader, resources) {

                var _frames = [];

                for (var i = 0; i < frames; i++) {
                    var _val = i < 10 ? '0' + i : i;
                    _frames.push(__WEBPACK_IMPORTED_MODULE_1_pixi_js__["Texture"].fromFrame(frame + _val + '.png'));
                }

                var _animation = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["extras"].AnimatedSprite(_frames),
                    _inc = 1;

                _animation.x = x + vm.pointsOffset.x;
                _animation.y = y + vm.pointsOffset.y;
                _animation.anchor.set(0);
                _animation.parentGroup = vm.animationLayer;
                _animation.loop = loop;
                _animation.alpha = 0;
                _animation.animationSpeed = 0.26;
                _animation.gotoAndStop(1);

                _animation.onComplete = function () {
                    if (name === vm.$dataStore.getters.getLastExposure) {
                        console.log(name, vm.$dataStore.getters.getLastExposure);
                        vm.$eventBus.$emit('powersurge:complete');
                    }
                };

                _animation.onLoop = function () {
                    if (_inc === vm.exposureObjects[name]._data.animation.loopDuration) {
                        this.gotoAndStop(vm.exposureObjects[name]._data.animation.frames - 1);
                        if (name === vm.$dataStore.getters.getLastExposure) {
                            setTimeout(function () {
                                vm.$eventBus.$emit('powersurge:complete');
                            }, 2000);
                        }
                        _inc = 1;
                    } else {
                        _inc++;
                    }
                };

                vm.residence.addChild(_animation);

                vm.animationObjects[name] = _animation;
            }
        },


        /**
         * @method createRoomDimmers
         * @description
         */
        createRoomDimmers: function createRoomDimmers() {

            _.each(vm.rooms, function (val, key) {
                // dimmer
                var _dimmer = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Graphics"]();
                _dimmer.nativeLines = true;
                _dimmer.lineStyle(0, 0x000000, 0);
                _dimmer.beginFill(0x000000, 0.70);
                _dimmer.drawRect(val.x, val.y, val.width, val.height);
                _dimmer.endFill();
                _dimmer.blendMode = __WEBPACK_IMPORTED_MODULE_1_pixi_js__["BLEND_MODES"].MULTIPLY;

                var _dimmerTexture = _dimmer.generateCanvasTexture();

                var _o = new __WEBPACK_IMPORTED_MODULE_1_pixi_js__["Sprite"](_dimmerTexture);

                _o._name = val.name;
                _o.interactive = false;
                _o.buttonMode = false;
                _o.cursor = 'pointer';
                _o.alpha = 0;
                _o.zOrder = 1000;
                _o.position.x = val.x /*+ vm.pointsOffset.x*/;
                _o.position.y = val.y /*+ vm.pointsOffset.y*/;
                _o.scale.x = 1;
                _o.scale.y = 1;
                _o.anchor.x = 0.5;
                _o.anchor.y = 0.5;
                _o.parentGroup = vm.dimLayer;

                vm.residence.addChild(_o);
                vm.dimmerObjects.push(_o);
            });
        },


        /**
         * @method animateDimmers
         * @description
         */
        animateDimmers: function animateDimmers() {

            var tl = new TimelineMax({
                paused: true,
                delay: 0.5,
                onUpdate: function onUpdate() {
                    vm.pixiApp.renderer.render(vm.pixiApp.stage);
                }
            });

            tl.add(__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.dimmerObjects, 0.3, { alpha: 1, ease: Quad.easeInOut }));
            tl.add(__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.dimmerObjects, 0.1, { alpha: 0.2, ease: Quad.easeInOut }));
            tl.add(__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.dimmerObjects, 0.3, { alpha: 1, ease: Quad.easeInOut }));
            tl.add(__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.dimmerObjects, 0.2, { alpha: 0, ease: Quad.easeInOut }));

            tl.play();
        },


        /**
         * @method playExposureAnimation
         * @description
         * @param {String} name
         */
        playExposureAnimation: function playExposureAnimation(name) {
            vm.animationObjects[name].alpha = 1;
            vm.animationObjects[name].gotoAndPlay(1);

            if (name === 'electrical-service-panel') {
                this.$eventBus.$emit('power-surge:dimmer');
            }
        },


        /**
         * @method resetExposureAnimations
         * @description
         */
        resetExposureAnimations: function resetExposureAnimations() {
            _.each(vm.animationObjects, function (val, key) {
                val.alpha = 0;
                val.gotoAndStop(1);
            });
        },


        /**
         * @method resizeResidence
         * @description
         */
        resizeResidence: function resizeResidence() {
            //console.log('resizeResidence');

            setTimeout(function () {
                var _container = $('#base-container'),
                    _width = _container.width(),
                    _height = _container.height(),
                    _fHeight = $('footer').height();

                if (vm.residence) {
                    var _tl = new TimelineMax({ paused: true });
                    _tl.add(__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.residence, 0.6, { x: _width * .5, ease: Quad.easeInOut }));
                    _tl.add(__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(vm.residence, 0.6, { y: _height * .5, ease: Quad.easeInOut }), '-=0.6');
                    _tl.play();
                }

                vm.pixiApp.renderer.resize(_width, _height);

                vm.pixiApp.renderer.render(vm.pixiApp.stage);
            }, 50);
        },


        /**
         * @method zoomIn
         * @description
         * @param {Number} duration
         * @param {Number} sx
         * @param {Number} sy
         * @param {*} easing
         */
        zoomIn: function zoomIn(duration, sx, sy, easing) {

            var _duration = duration ? duration : vm.scale.duration.in,
                _sx = sx ? sx : vm.scale.max,
                _sy = sy ? sy : vm.scale.max,
                _easing = easing ? easing : Quad.easeInOut,
                tl = new TimelineMax({
                // onUpdate: vm.rimJob,
                // onUpdateScope: vm.pixiApp.stage,
                onStart: function onStart() {
                    if (vm.$dataStore.state.interactive.transitioned) {
                        //vm.scaleExposurePoints();
                    }
                },
                onComplete: function onComplete() {
                    vm.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: true });
                }
            });

            // scale residence
            tl.to(vm.residence.scale, _duration, {
                x: _sx,
                y: _sy,
                ease: _easing
            }, 0);

            // position residence
            tl.to(vm.residence.position, _duration, {
                x: vm.pixiApp.renderer.width / 2 - vm.zoomInOffset.x, /* include panel width in x position calc */
                y: vm.pixiApp.renderer.height / 2 - vm.zoomInOffset.y,
                ease: _easing
            }, 0);
        },


        /**
         * @method zoomOut
         * @description
         * @param {Number} duration
         * @param {Number} sx
         * @param {Number} sy
         * @param {*} easing
         */
        zoomOut: function zoomOut(duration, sx, sy, easing) {

            var _duration = duration ? duration : vm.scale.duration.out,
                _sx = sx ? sx : vm.scale.min,
                _sy = sy ? sy : vm.scale.min,
                _easing = easing ? easing : Quad.easeInOut,
                tl = new TimelineMax({
                // onUpdate: vm.rimJob,
                // onUpdateScope: vm.pixiApp.stage,
                onComplete: function onComplete() {
                    vm.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: false });

                    if (vm.$dataStore.state.interactive.transitioned) {
                        //vm.scaleExposurePoints();
                    }
                }
            });

            // scale residence
            tl.to(vm.residence.scale, _duration, {
                x: _sx,
                y: _sy,
                ease: _easing
            }, 0);

            // scale residence
            tl.to(vm.residence, _duration, {
                x: vm.pixiApp.renderer.width / 2,
                y: vm.pixiApp.renderer.height / 2,
                ease: _easing
            }, 0);
        },


        /**
         * @method zoomTo
         * @description
         * @param {Number} duration
         * @param {Number} sx
         * @param {Number} sy
         * @param {*} easing
         * @param {Object} evt
         * @param {Object} obj
         */
        zoomTo: function zoomTo(duration, sx, sy, easing, evt, obj) {
            //console.log('zoomTo', duration, sx, sy, easing, evt, obj);

            var _duration = duration ? duration : 1,
                _sx = sx ? sx : vm.scale.min,
                _sy = sy ? sy : vm.scale.min,
                _easing = easing ? easing : Quad.easeInOut,

            /*_pos = evt.data.getLocalPosition(vm.pixiApp.stage),*/
            tl = new TimelineMax({
                // onUpdate: vm.rimJob,
                // onUpdateScope: vm.pixiApp.stage,
                onStart: function onStart() {
                    if (vm.$dataStore.state.interactive.transitioned) {
                        //vm.scaleExposurePoints();
                    }
                },
                onComplete: function onComplete() {
                    setTimeout(function () {
                        if (name) {
                            //vm.playExposureAnimation(obj.slug);
                        }
                    }, 600);
                }
            });

            // set pan duration, if we need to zoom in we then use '-='. If not, we use the full duration needed to tween.
            var panDuration = _duration;

            // zoom into residence if we are not already
            if (!this.$dataStore.state.interactive.zoomed) {
                panDuration = '-=' + _duration;

                this.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: true });

                tl.to(vm.residence.scale, _duration, {
                    x: _sx,
                    y: _sy,
                    ease: _easing
                });
            }

            // position residence, try to center to interactive point
            tl.to(vm.residence.position, _duration, {
                x: vm.pixiApp.renderer.width / 2 - obj.position.x - 375 / 2, /* include panel width in x position calc */
                y: vm.pixiApp.renderer.height / 2 - obj.position.y,
                ease: _easing
            }, 0);
        },


        /**
         * @method transitionIn
         * @description
         */
        transitionIn: function transitionIn(duration, sx, sy, easing) {

            var _duration = duration ? duration : vm.scale.duration.out,
                _sx = sx ? sx : 0.20,
                _sy = sy ? sy : 0.20,
                _easing = easing ? easing : Quad.easeInOut,
                tl = new TimelineMax({
                onComplete: function onComplete() {
                    vm.animateExposurePoints();

                    if (vm.debug) {
                        vm.debugExposureImages();
                    }
                }
            });

            // scale residence out to single zoom
            tl.to(vm.residence.scale, _duration, {
                x: vm.scale.wide,
                y: vm.scale.wide,
                ease: _easing
            }, 0);

            // scale residence out to single zoom
            tl.to(vm.residence.scale, _duration, {
                x: vm.scale.min,
                y: vm.scale.min,
                ease: _easing,
                delay: 1.5
            });
        },


        /**
         * @method transitionOut
         * @description
         */
        transitionOut: function transitionOut() {

            setTimeout(function () {
                vm.zoomIn();
            }, 300);
        },


        /**
         * @method animate
         * @description
         */
        animate: function animate() {
            vm.pixiApp.renderer.render(vm.pixiApp.stage);
            requestAnimationFrame(vm.animate);
        },


        /**
         * @method clamp
         * @description
         * @param {Number} val
         * @param {Number} min
         * @param {Number} max
         * @return {Number}
         */
        clamp: function clamp(val, min, max) {

            if (min > max) {
                var tempMax = max;
                max = min;
                min = tempMax;
            }

            if (val < min) {
                return min;
            }
            if (val > max) {
                return max;
            }

            return val;
        },


        /**
         * @method rimJob
         * @description
         */
        // rimJob() {
        // let _minX = (vm.residence.width / 2),
        //     _minY = (vm.residence.height / 2) - vm.offset.y,
        //     _maxX = (vm.pixiApp.renderer.width - (vm.residence.width / 2)) - vm.offset.x,
        //     _maxY = vm.pixiApp.renderer.height - (vm.residence.height / 2);
        //
        // vm.residence.position.x = vm.clamp(vm.residence.position.x, _minX, _maxX);
        // vm.residence.position.y = vm.clamp(vm.residence.position.y, _minY, _maxY);

        // let xClamp = vm.clamp(vm.residence.position.x, _minX, _maxX);
        // let yClamp = vm.clamp(vm.residence.position.y, _minY, _maxY);
        // TweenMax.to(vm.residence, .5, { x:xClamp, y:yClamp });
        // },

        /**
         * @method togglePanel
         * @description
         * @param {String} type
         * @param {String} slug
         * @param {String} service
         * @param {String} premise
         */
        togglePanel: function togglePanel(type, slug, service, premise) {
            //console.info('%ctogglePanel', 'color:orange;', type, slug, premise);

            this.$eventBus.$emit('panel:toggle', {
                panel: type,
                slug: slug,
                service: service,
                premise: premise
            });
        },


        /**
         * @method getCSSColorVariable
         * @description
         * @param color
         * @return {string}
         */
        getCSSColorVariable: function getCSSColorVariable(color) {
            var _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

            if (!_propVal) {
                var _color = color.replace('--', '$');
                _propVal = window.appTheme.colors[_color];
            }

            //console.log('_propVal', _propVal);

            return _propVal;
        },


        /**
         * @method timeStampMs
         * @description
         * @return {number}
         */
        timeStampMs: function timeStampMs() {
            return window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
        },
        dec2Hex: function dec2Hex(dec) {
            dec = parseInt(dec, 10);
            if (!isNaN(dec)) {
                hexChars = "0123456789ABCDEF";
                if (dec > 255) {
                    return "Out of Range";
                }
                var i = dec % 16;
                var j = (dec - i) / 16;
                result = "0x";
                result += hexChars.charAt(j) + hexChars.charAt(i);
                return result;
            } else {
                return NaN;
            }
        }
    }

});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'share-controls',

    components: {},

    data: function data() {
        return {
            open: false
        };
    },


    computed: {
        activeShare: function activeShare() {
            return this.$dataStore.getters.getActiveShare;
        },
        shareData: function shareData() {
            return this.$dataStore.getters.getShareData;
        },
        shareUrl: function shareUrl() {
            return window.location.href;
        },
        shareMessage: function shareMessage() {
            return this.shareData.message;
        },
        shareTitle: function shareTitle() {
            var cData = this.$dataStore.getters.getCompany;
            return cData.company_name + ' Residential Microsite';
        }
    },

    created: function created() {

        vm = this;

        this.$eventBus.$on('share:toggle', function () {
            vm.$dataStore.dispatch('ACTIVE_SHARE', { val: !vm.activeShare });
        });

        this.$eventBus.$on('share:close', function () {
            vm.$dataStore.dispatch('ACTIVE_SHARE', { val: false });
        });
    },
    mounted: function mounted() {

        vm = this;

        addthis.init();
        addthis.toolbox('.addthis_toolbox');
    },


    methods: {
        clickOutside: function clickOutside(evt) {
            evt.preventDefault();
            document.removeEventListener('click', vm.clickOutside, false);
            this.$dataStore.dispatch('ACTIVE_SHARE', { val: false });
        },
        closeShares: function closeShares() {
            vm.$dataStore.dispatch('ACTIVE_SHARE', { val: false });
        }
    },

    watch: {

        activeShare: function activeShare(nVal) {
            if (nVal) {
                setTimeout(function () {
                    document.addEventListener('click', vm.clickOutside, false);
                }, 1500);
            } else {
                document.removeEventListener('click', vm.clickOutside, false);
            }
        }

    }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShareControls_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShareControls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ShareControls_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'sidebar-controls',

    components: {
        ShareControls: __WEBPACK_IMPORTED_MODULE_0__ShareControls_vue___default.a
    },

    data: function data() {
        return {};
    },


    computed: {
        aboutPosition: function aboutPosition() {
            return this.$dataStore.getters.getAboutPosition;
        },
        zoomed: function zoomed() {
            return this.$dataStore.getters.getZoomedState;
        },
        surging: function surging() {
            return this.$dataStore.getters.getPowerSurgeState;
        },
        pdfDownload: function pdfDownload() {
            return this.$dataStore.getters.getCompanyPDF;
        }
    },

    created: function created() {
        //console.info('%cSidebarControls::created', 'color:dodgerblue;');
        //console.log(this.$dataStore.state.company);
    },
    mounted: function mounted() {
        //console.info('%cSidebarControls::mounted', 'color:green;');

        vm = this;

        vm.$eventBus.$emit('residence:resize');

        setTimeout(function () {
            vm.$eventBus.$emit('controls:entered');
        }, 300);
    },


    methods: {

        /**
         * @method togglePanel
         * @description
         * @param {String} type
         */
        togglePanel: function togglePanel(type, slug, evt) {
            //console.info('%ctogglePanel', 'color:orange;');

            if (this.$dataStore.getters.getPowerSurgeState) {
                this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                this.$dataStore.dispatch('POWER_SURGE', { val: false });
                this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                this.$eventBus.$emit('power-surge:end');
            }

            switch (type) {
                case 'panel-content-about':
                    vm.trackEvent('About Button', 'Sidebar');
                    break;
            }

            this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug });
        },


        /**
         * @method zoomIn
         * @description
         */
        zoomIn: function zoomIn() {
            //console.info('%czoomIn', 'color:orange;');
            if (this.surging) {
                return;
            }
            vm.trackEvent('Zoom Button', 'In');
            this.$eventBus.$emit('panel:close');
            this.$eventBus.$emit('residence:zoomin');
            this.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: true });
        },


        /**
         * @method zoomOut
         * @description
         */
        zoomOut: function zoomOut() {
            //console.info('%czoomOut', 'color:orange;');
            if (this.surging) {
                return;
            }
            vm.trackEvent('Zoom Button', 'Out');
            this.$eventBus.$emit('panel:close');
            this.$eventBus.$emit('residence:zoomout');
            this.$dataStore.dispatch('ZOOM_INTERACTIVE', { val: false });
        },


        /**
         * @method shareApp
         * @description
         */
        shareApp: function shareApp() {
            //console.info('%cshareApp', 'color:orange;');
            this.$eventBus.$emit('panel:close');
            this.$eventBus.$emit('share:toggle');
        },


        /**
         * @method downloadDocs
         * @description
         */
        downloadDocs: function downloadDocs() {
            //console.info('%cdownloadDocs', 'color:orange;');
            this.$eventBus.$emit('panel:close');
            this.$eventBus.$emit('download:document');
            confirm('Download Document...');
        },
        panelDown: function panelDown(evt) {
            evt.stopPropagation();
        },
        trackEvent: function trackEvent(action, label) {
            gtag('event', action, {
                'event_category': 'MBRe: Residential',
                'event_label': label || ''
            });
        }
    },

    events: {}

});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelContentAbout_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PanelContentAbout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PanelContentAbout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelContentContact_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelContentContact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PanelContentContact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelContentCoverages_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelContentCoverages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PanelContentCoverages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContentExposure_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContentExposure_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelContentExposure_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelContentPowerSurge_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelContentPowerSurge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelContentPowerSurge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelContentPrivacy_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelContentPrivacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PanelContentPrivacy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelContentTerms_vue__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelContentTerms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PanelContentTerms_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var vm = {};

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'sidebar-panel',

    components: {
        PanelContentAbout: __WEBPACK_IMPORTED_MODULE_0__PanelContentAbout_vue___default.a,
        PanelContentContact: __WEBPACK_IMPORTED_MODULE_1__PanelContentContact_vue___default.a,
        PanelContentCoverages: __WEBPACK_IMPORTED_MODULE_2__PanelContentCoverages_vue___default.a,
        PanelContentExposure: __WEBPACK_IMPORTED_MODULE_3__PanelContentExposure_vue___default.a,
        PanelContentPowerSurge: __WEBPACK_IMPORTED_MODULE_4__PanelContentPowerSurge_vue___default.a,
        PanelContentPrivacy: __WEBPACK_IMPORTED_MODULE_5__PanelContentPrivacy_vue___default.a,
        PanelContentTerms: __WEBPACK_IMPORTED_MODULE_6__PanelContentTerms_vue___default.a
    },

    data: function data() {
        return {
            domPanel: null
        };
    },


    computed: {
        activePanel: function activePanel() {
            return this.$dataStore.getters.getActivePanel;
        },


        panelOpen: {
            get: function get() {
                return vm.$dataStore.getters.getPanelState;
            },
            set: function set(nVal) {
                vm.$dataStore.dispatch('PANEL_OPEN', { val: nVal });
                if (nVal === false) {
                    vm.$dataStore.dispatch('ACTIVE_PANEL', { val: null });

                    if (vm.$dataStore.getters.getPowerSurgeState) {
                        vm.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                        vm.$dataStore.dispatch('POWER_SURGE', { val: false });
                        vm.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                        vm.$eventBus.$emit('power-surge:end');
                    }

                    vm.$eventBus.$emit('points:state:reset');

                    // show points
                    vm.$eventBus.$emit('points:show');

                    // show instructions if not already shown...
                    vm.$eventBus.$emit('cta:show');
                }
            }
        },

        powerSurge: function powerSurge() {
            return this.$dataStore.state.interactive.powerSurge;
        }
    },

    created: function created() {
        //console.info('%csidebar-panel::created', 'color:dodgerblue;');

        vm = this;

        // panel:toggle event handler
        vm.$eventBus.$on('panel:toggle', function (obj) {

            vm.$eventBus.$emit('share:close');

            // panel IS open & current active panel IS the requested panel (CLOSE PANEL, ACTIVE PANEL NULL)
            if (vm.$dataStore.state.interactive.panelOpen && obj === vm.$dataStore.state.interactive.activePanel) {

                vm.closePanel();

                // panel IS NOT open, requested panel exists (OPEN PANEL, SET ACTIVE PANEL)
            } else if (!vm.$dataStore.state.interactive.panelOpen && obj) {

                vm.$dataStore.dispatch('PANEL_OPEN', { val: true });
                vm.$dataStore.dispatch('ACTIVE_PANEL', { val: obj });

                // panel IS open, requested panel exists (CLOSE PANEL, ACTIVE PANEL NULL, SET ACTIVE PANEL, OPEN PANEL)
            } else if (vm.$dataStore.state.interactive.panelOpen && obj) {

                if (vm.$dataStore.state.interactive.activePanel.slug === obj.slug) {
                    vm.closePanel();
                } else {
                    vm.closePanel();

                    setTimeout(function () {
                        vm.$dataStore.dispatch('PANEL_OPEN', { val: true });
                        vm.$dataStore.dispatch('ACTIVE_PANEL', { val: obj });
                    }, 600);
                }
            }

            // show instructions if not already shown...
            vm.$eventBus.$emit('cta:show');
        });

        vm.$eventBus.$on('panel:close', vm.closePanel);

        var debouncedResize = _.debounce(vm.setPanel, 30);
        window.addEventListener('resize', debouncedResize, false);
    },
    mounted: function mounted() {
        //console.info('%csidebar-panel::mounted', 'color:green;');

        vm = this;

        vm.setPanel();
    },


    methods: {
        clickOutside: function clickOutside(evt) {
            evt.stopPropagation();
            document.removeEventListener('click', vm.clickOutside, false);

            if (this.$dataStore.getters.getPowerSurgeState) {
                this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                this.$dataStore.dispatch('POWER_SURGE', { val: false });
                this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                this.$eventBus.$emit('power-surge:end');
            }

            this.$dataStore.dispatch('PANEL_OPEN', { val: false });
            this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });

            // show instructions if not already shown...
            vm.$eventBus.$emit('cta:show');

            vm.$eventBus.$emit('points:state:reset');

            // show points
            vm.$eventBus.$emit('points:show');
        },
        setPanel: function setPanel() {
            var _fHeight = $('footer').height();
            //console.log('_fHeight', _fHeight);

            $('.sidebar-panel').css({
                height: 'calc(100% - ' + _fHeight + 'px)'
            });
        },
        panelDown: function panelDown(evt) {
            evt.stopPropagation();
        },


        /**
         * @method togglePanel
         * @description
         * @param {String} type
         * @param {String} slug
         * @param {Object} evt
         * @param {Boolean} service
         * @param {Boolean} premise
         */
        togglePanel: function togglePanel(type, slug, evt, service, premise) {
            evt.stopPropagation();
            this.$eventBus.$emit('panel:toggle', { panel: type, slug: slug, service: service, premise: premise });
        },
        closePanel: function closePanel() {
            this.$dataStore.dispatch('PANEL_OPEN', { val: false });
            this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });

            vm.$eventBus.$emit('points:state:reset');

            // show points
            vm.$eventBus.$emit('points:show');
        }
    },

    watch: {

        activePanel: function activePanel(nVal) {
            if (nVal) {
                setTimeout(function () {
                    document.addEventListener('click', vm.clickOutside, false);
                }, 1500);
            } else {
                document.removeEventListener('click', vm.clickOutside, false);
            }
        }

    }

});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(28);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

// STATE
var state = {
    err404: false,
    loading: true,
    loadingData: true,
    serverDateTime: null,
    interactive: {
        loaded: false,
        pixiApp: null,
        entered: false,
        transitioned: false,
        zoomed: false,
        powerSurgeEnabled: false,
        powerSurge: false,
        powerSurgeOverlay: false,
        activePanel: null,
        activeShare: false,
        panelOpen: false,
        lastExposure: null,
        instructed: false
    },
    globals: [],
    company: {},
    exposures: [],
    exposureData: [],
    usStates: [],
    canadianProvinces: [],
    google: {
        recaptcha: {
            siteKey: '6Ld61i0UAAAAAOIf5Nuj-32Np374MWrLDTM1FBMe',
            theme: 'light',
            type: 'image',
            size: 'normal',
            tabindex: 50,
            callback: null,
            expCallback: null
        }
    }
};

// ACTIONS
var actions = {

    LOAD_APP_DATA: function LOAD_APP_DATA(_ref) {
        var state = _ref.state,
            commit = _ref.commit;

        //console.info('%cLOAD_APP_DATA', 'color:aqua;');

        var _apiURLEnv = "/data/getCompany.json.php";

        var _apiURL = __WEBPACK_IMPORTED_MODULE_4__main__["router"].history.current.query.id ? _apiURLEnv + '?id=' + __WEBPACK_IMPORTED_MODULE_4__main__["router"].history.current.query.id : _apiURLEnv;

        //////////////
        // get us state data
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].usStateData).then(function (res) {
            // set us state data
            commit('SET_US_STATE_DATA', { val: res.data });
        }, function (err) {
            console.error(err);
        });
        //////////////


        //////////////
        // get canadian province data
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].canadianProvinceData).then(function (res) {
            // set canadian province data
            commit('SET_CANADIAN_PROVINCE_DATA', { val: res.data });
        }, function (err) {
            console.error(err);
        });
        //////////////


        //////////////
        // get static exposure data
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].staticExposureData).then(function (_res) {

            // set static exposure data
            commit('SET_EXPOSURE_DATA', { val: _res.data });

            //////////////
            // get app live api data
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_apiURL).then(function (res) {

                // set 404 error if we do not get data back from the api
                if (!res.data || res.data <= '') {
                    commit('SET_404', { val: true });
                    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {});
                } else {
                    commit('SET_404', { val: false });
                }

                var appData = res.data;

                commit('SET_COMPANY_DATA', { company: appData });

                function merge(a, b, id, keys) {
                    var array = [],
                        object = {};

                    function m(c) {
                        if (!object[c[id]]) {
                            object[c[id]] = {};
                            object[c[id]][id] = c[id];
                            array.push(object[c[id]]);
                        }
                        keys.forEach(function (k) {
                            if (k in c) {
                                object[c[id]][k] = c[k];
                            }
                        });
                    }
                    a.forEach(m);
                    b.forEach(m);
                    return array;
                }

                // merge exposures with exposureData (static positions + animations)
                var _mergedExposures = merge(state.company.occupancies[0].exposures, state.exposureData, 'exposure_slug', ['coverage', 'x', 'y', 'animation', 'exposure_id', 'exposure_type', 'exposure_name', 'exposure_label', 'hazard', 'lead_in', 'loss_example', 'maintenance_tip', 'pdf', 'media', 'enabled', 'graphic', 'mobile']);
                commit('SET_EXPOSURES', { val: _mergedExposures });
                commit('SET_EXPOSURE_DATA', { val: _mergedExposures });

                // merge coverages with exposureData (static positions + animations)
                var _mergedCoverages = merge(state.company.occupancies[0].coverages, state.exposureData, 'exposure_slug', ['coverage', 'x', 'y', 'animation', 'exposure_id', 'exposure_type', 'exposure_name', 'exposure_label', 'hazard', 'lead_in', 'loss_example', 'maintenance_tip', 'pdf', 'media', 'enabled', 'graphic', 'mobile']);
                commit('SET_EXPOSURES', { val: _mergedCoverages });
                commit('SET_EXPOSURE_DATA', { val: _mergedCoverages });

                commit('SET_LOADING', { val: false });
                commit('SET_LOADING_DATA', { val: false });
            }, function (err) {
                console.error(err);
                commit('SET_404', { val: true });
            });
            //////////////
        }, function (err) {
            console.error(err);
            commit('SET_404', { val: true });
        });
        //////////////
    },

    STATUS_404: function STATUS_404(_ref2, payload) {
        var state = _ref2.state,
            commit = _ref2.commit;

        commit('SET_404', { val: payload.val });
    },

    INTERACTIVE: function INTERACTIVE(_ref3, payload) {
        var state = _ref3.state,
            commit = _ref3.commit;

        commit('SET_INTERACTIVE', { val: payload.val });
    },

    LOADED: function LOADED(_ref4, payload) {
        var state = _ref4.state,
            commit = _ref4.commit;

        commit('SET_LOADED', { val: payload.val });
    },

    ENTER_INTERACTIVE: function ENTER_INTERACTIVE(_ref5, payload) {
        var state = _ref5.state,
            commit = _ref5.commit;

        commit('SET_ENTERED', { val: payload.val });
    },

    TRANSITION_INTERACTIVE: function TRANSITION_INTERACTIVE(_ref6, payload) {
        var state = _ref6.state,
            commit = _ref6.commit;

        commit('SET_TRANSITIONED', { val: payload.val });
    },

    INSTRUCTED: function INSTRUCTED(_ref7, payload) {
        var state = _ref7.state,
            commit = _ref7.commit;

        commit('SET_INSTRUCTED', { val: payload.val });
    },

    ZOOM_INTERACTIVE: function ZOOM_INTERACTIVE(_ref8, payload) {
        var state = _ref8.state,
            commit = _ref8.commit;

        commit('SET_ZOOMED', { val: payload.val });
    },

    POWER_SURGE: function POWER_SURGE(_ref9, payload) {
        var state = _ref9.state,
            commit = _ref9.commit;

        commit('SET_POWER_SURGE', { val: payload.val });
    },

    POWER_SURGE_STATE: function POWER_SURGE_STATE(_ref10, payload) {
        var state = _ref10.state,
            commit = _ref10.commit;

        commit('SET_POWER_SURGE_STATE', { val: payload.val });
    },

    POWER_SURGE_OVERLAY: function POWER_SURGE_OVERLAY(_ref11, payload) {
        var state = _ref11.state,
            commit = _ref11.commit;

        commit('SET_POWER_SURGE_OVERLAY', { val: payload.val });
    },

    ACTIVE_PANEL: function ACTIVE_PANEL(_ref12, payload) {
        var state = _ref12.state,
            commit = _ref12.commit;

        commit('SET_ACTIVE_PANEL', { val: payload.val });
    },

    PANEL_OPEN: function PANEL_OPEN(_ref13, payload) {
        var state = _ref13.state,
            commit = _ref13.commit;

        commit('SET_PANEL_OPEN', { val: payload.val });
    },

    ACTIVE_SHARE: function ACTIVE_SHARE(_ref14, payload) {
        var state = _ref14.state,
            commit = _ref14.commit;

        commit('SET_ACTIVE_SHARE', { val: payload.val });
    },

    LAST_EXPOSURE_ANIMATION: function LAST_EXPOSURE_ANIMATION(_ref15, payload) {
        var state = _ref15.state,
            commit = _ref15.commit;

        commit('SET_LAST_EXPOSURE', { val: payload.val });
    }

};

// MUTATIONS
var mutations = {

    SET_COMPANY_DATA: function SET_COMPANY_DATA(state, _ref16) {
        var company = _ref16.company;

        state.company = company;
    },

    SET_LOADING: function SET_LOADING(state, _ref17) {
        var val = _ref17.val;

        state.loading = val;
    },

    SET_LOADING_DATA: function SET_LOADING_DATA(state, _ref18) {
        var val = _ref18.val;

        state.loadingData = val;
    },

    SET_404: function SET_404(state, _ref19) {
        var val = _ref19.val;

        state.err404 = val;
    },

    SET_INTERACTIVE: function SET_INTERACTIVE(state, _ref20) {
        var val = _ref20.val;

        state.interactive.pixiApp = val;
    },

    SET_LOADED: function SET_LOADED(state, _ref21) {
        var val = _ref21.val;

        state.interactive.loaded = val;
    },

    SET_ENTERED: function SET_ENTERED(state, _ref22) {
        var val = _ref22.val;

        state.interactive.entered = val;
    },

    SET_TRANSITIONED: function SET_TRANSITIONED(state, _ref23) {
        var val = _ref23.val;

        state.interactive.transitioned = val;
    },

    SET_INSTRUCTED: function SET_INSTRUCTED(state, _ref24) {
        var val = _ref24.val;

        state.interactive.instructed = val;
    },

    SET_ZOOMED: function SET_ZOOMED(state, _ref25) {
        var val = _ref25.val;

        state.interactive.zoomed = val;
    },

    SET_POWER_SURGE: function SET_POWER_SURGE(state, _ref26) {
        var val = _ref26.val;

        state.interactive.powerSurge = val;
    },

    SET_POWER_SURGE_STATE: function SET_POWER_SURGE_STATE(state, _ref27) {
        var val = _ref27.val;

        state.interactive.powerSurgeState = val;
    },

    SET_POWER_SURGE_OVERLAY: function SET_POWER_SURGE_OVERLAY(state, _ref28) {
        var val = _ref28.val;

        state.interactive.powerSurgeOverlay = val;
    },

    SET_ACTIVE_PANEL: function SET_ACTIVE_PANEL(state, _ref29) {
        var val = _ref29.val;

        state.interactive.activePanel = val;
    },

    SET_PANEL_OPEN: function SET_PANEL_OPEN(state, _ref30) {
        var val = _ref30.val;

        state.interactive.panelOpen = val;
    },

    SET_ACTIVE_SHARE: function SET_ACTIVE_SHARE(state, _ref31) {
        var val = _ref31.val;

        state.interactive.activeShare = val;
    },

    SET_EXPOSURE_DATA: function SET_EXPOSURE_DATA(state, _ref32) {
        var val = _ref32.val;

        state.exposureData = val;
    },

    SET_EXPOSURES: function SET_EXPOSURES(state, _ref33) {
        var val = _ref33.val;


        var _array = [];

        // filter exposures for enabled status
        _.each(val, function (_val) {
            if (_.find(state.company.occupancies[0].exposures, { 'exposure_slug': _val.exposure_slug })) {
                _val.enabled = true;
                _array.push(_val);
            } else if (_.find(state.company.occupancies[0].coverages, { 'exposure_slug': _val.exposure_slug })) {
                _val.enabled = true;
                _array.push(_val);
            }
        });

        state.exposures = _array;
    },

    SET_LAST_EXPOSURE: function SET_LAST_EXPOSURE(state, _ref34) {
        var val = _ref34.val;

        state.interactive.lastExposure = val;
    },

    SET_US_STATE_DATA: function SET_US_STATE_DATA(state, _ref35) {
        var val = _ref35.val;

        state.usStates = val;
    },

    SET_CANADIAN_PROVINCE_DATA: function SET_CANADIAN_PROVINCE_DATA(state, _ref36) {
        var val = _ref36.val;

        state.canadianProvinces = val;
    }

};

// GETTERS
var getters = {

    getParams: function getParams(state) {
        return state.route.params;
    },

    get404Status: function get404Status(state) {
        return state.err404;
    },

    getInteractive: function getInteractive(state) {
        return state.interactive.pixiApp;
    },

    getLoadedState: function getLoadedState(state) {
        return state.interactive.loaded;
    },

    getEnteredState: function getEnteredState(state) {
        return state.interactive.entered;
    },

    getTransitionedState: function getTransitionedState(state) {
        return state.interactive.transitioned;
    },

    getInstructedState: function getInstructedState(state) {
        return state.interactive.instructed;
    },

    getZoomedState: function getZoomedState(state) {
        return state.interactive.zoomed;
    },

    getActivePanel: function getActivePanel(state) {
        return state.interactive.activePanel;
    },

    getPanelState: function getPanelState(state) {
        return state.interactive.panelOpen;
    },

    getActiveShare: function getActiveShare(state) {
        return state.interactive.activeShare;
    },

    getPowerSurge: function getPowerSurge(state, getters) {
        return _.filter(getters.getOccupancies.other, { 'exposure_slug': 'power-surge' });
    },

    getPowerSurgeState: function getPowerSurgeState(state) {
        return state.interactive.powerSurge;
    },

    getPowerSurgeOverlayState: function getPowerSurgeOverlayState(state) {

        return state.interactive.powerSurgeOverlay;
    },

    getPowerSurgeAnimations: function getPowerSurgeAnimations(state, getters) {
        return _.filter(getters.getExposures, function (o) {
            return o.animation.enabled === true && o.animation.powerGrid === true;
        });
    },

    getReCaptchaConfig: function getReCaptchaConfig(state) {
        return state.google.recaptcha;
    },

    getCompany: function getCompany(state) {
        return state.company;
    },

    getCompanyLogo: function getCompanyLogo(state, getters) {
        var _logo = getters.getCompany;
        _logo = _logo.logo;
        return _logo;
    },

    getCompanyPDF: function getCompanyPDF(state) {
        return state.company.company_info_pdf;
    },

    getAboutPosition: function getAboutPosition(state) {
        return state.company.about_button_placement;
    },

    getPrivacyData: function getPrivacyData(state) {
        return state.company.privacy;
    },

    getTermsData: function getTermsData(state) {
        return state.company.disclaimer;
    },

    getLandingData: function getLandingData(state) {
        var _obj = {};
        _obj.title = state.company.landing_title;
        _obj.intro = state.company.landing_intro;
        _obj.tagline = state.company.landing_tagline;
        return _obj;
    },

    getCompanyContactData: function getCompanyContactData(state) {
        var _obj = {};
        _obj.slug = state.company.slug;
        _obj.name = state.company.company_name;
        _obj.email = state.company.contact_dest;
        _obj.address1 = state.company.address1;
        _obj.address2 = state.company.address2;
        _obj.city = state.company.city;
        _obj.state = state.company.state;
        _obj.zipcode = state.company.zip;
        _obj.phone = state.company.phone;
        _obj.fax = state.company.fax;
        _obj.form_label = state.company.contact_label;
        _obj.form_header = state.company.contact_text;
        _obj.form_intro = state.company.contact_intro;
        _obj.form_type = state.company.contact_form_type;
        _obj.form_fields = state.company.contact_form_fields;
        _obj.form_thanks_title = state.company.contact_thank_you_heading;
        _obj.form_thanks_msg = state.company.contact_thank_you_msg;
        _obj.contact_title = state.company.contact_text;
        _obj.show_company_name = state.company.company_name_show;
        return _obj;
    },

    getAboutContent: function getAboutContent(state, getters) {
        var _obj = {};
        _obj.about_label = state.company.about_label;
        _obj.about_heading_1 = state.company.about_heading_1;
        _obj.about_body_1 = state.company.about_body_1;
        _obj.about_heading_2 = state.company.about_heading_2;
        _obj.about_body_2 = state.company.about_body_2;
        return _obj;
    },

    getOccupancies: function getOccupancies(state) {
        return state.company.occupancies[0];
    },

    getExposureData: function getExposureData(state) {
        return state.exposureData;
    },

    getExposures: function getExposures(state) {
        return state.exposures;
    },

    getExposureBySlug: function getExposureBySlug(state, getters) {
        return function (slug) {
            return _.find(getters.getExposures, { 'exposure_slug': slug });
        };
    },

    getLastExposure: function getLastExposure(state) {
        return state.interactive.lastExposure;
    },

    getExposureDisclaimer: function getExposureDisclaimer(state) {
        return state.company.occupancies[0].occupancy_exposure_disclaimer;
    },

    getAdditionalCoveragesLabel: function getAdditionalCoveragesLabel(state) {
        return state.company.occupancies[0].occupancy_additional_coverages_label;
    },

    getServiceLineCoverageLabel: function getServiceLineCoverageLabel(state) {
        return state.company.occupancies[0].occupancy_service_line_coverage_label;
    },

    getOffPremiseCoverageLabel: function getOffPremiseCoverageLabel(state) {
        return state.company.occupancies[0].occupancy_off_premise_coverage_label;
    },

    getCoverages: function getCoverages(state, getters) {
        return _.filter(getters.getExposures, { 'coverage': true });
    },

    getServiceLineCoverages: function getServiceLineCoverages(state, getters) {
        return _.filter(getters.getExposures, function (o) {
            return o.enabled === true && o.coverage === true && o.exposure_type === 'service-line';
        });
    },

    getOffPremisesCoverages: function getOffPremisesCoverages(state, getters) {
        return _.filter(getters.getExposures, function (o) {
            return o.enabled === true && o.coverage === true && o.exposure_type === 'off-premise';
        });
    },

    getCoveragesByType: function getCoveragesByType(state, getters) {
        return function (type) {
            return _.filter(getters.getCoverages, { 'exposure_type': type });
        };
    },

    getCoverageContent: function getCoverageContent(state) {
        var obj = {};
        obj.cta_offpremise = state.company.occupancies[0].occupancy_off_premise_coverage_cta;
        obj.cta_serviceline = state.company.occupancies[0].occupancy_service_line_coverage_cta;
        return obj;
    },

    getPowerSurgeData: function getPowerSurgeData(state) {
        return _.find(state.company.occupancies[0].other, { 'exposure_slug': 'power-surge' });
    },

    getUSStateData: function getUSStateData(state) {
        return state.usStates;
    },

    getCanadianProvinceData: function getCanadianProvinceData(state) {
        return state.canadianProvinces;
    },

    getShareData: function getShareData(state) {
        return state.company.social_sharing;
    }

};

// MODULES
var modules = {};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters,
    modules: modules
}));

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(449),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f7c8ec0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06688970",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-394152ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
  __webpack_require__(265)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0516318a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17913b96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d302640",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(451),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-323daf7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
  __webpack_require__(270)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(445),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e20fdbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(283)
  __webpack_require__(282)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(454),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b636d9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
  __webpack_require__(300)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-731e375c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(294)
  __webpack_require__(293)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(462),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a70ec39",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-156f46b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62b6fa7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(465),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70d9a618",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72eeb05c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7480ddaf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(460),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-654071da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fc71c08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(275)
  __webpack_require__(274)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-191b7e2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(292)
  __webpack_require__(291)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68a62dd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(281)
  __webpack_require__(280)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ca44956",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-210d3647",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53d9b90b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(471),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-edea1454",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(296)
  __webpack_require__(295)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ded4014",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "landing-transition",
      "enter-active-class": "animated slideInDown",
      "leave-active-class": "animated slideOutUp"
    }
  }, [_c('div', {
    staticClass: "landing",
    attrs: {
      "data-size": "lg"
    }
  }, [(_vm.hasSupport) ? _c('div', {
    staticClass: "content"
  }, [(!_vm.has404) ? _c('h1', [_vm._v(_vm._s(_vm.landing.title))]) : _vm._e(), _vm._v(" "), (!_vm.has404) ? _c('h2', [_vm._v(_vm._s(_vm.landing.tagline))]) : _vm._e(), _vm._v(" "), (_vm.has404) ? _c('h1', [_vm._v(_vm._s(_vm.status.err404.title))]) : _vm._e(), _vm._v(" "), (_vm.has404) ? _c('h2', [_vm._v(_vm._s(_vm.status.err404.msg))]) : _vm._e(), _vm._v(" "), _c('progress-button', {
    attrs: {
      "method": _vm.openSesame,
      "loadingLabel": _vm.loadingLabel,
      "readyLabel": _vm.buttonLabel
    }
  })], 1) : _c('div', {
    staticClass: "content unsupported"
  }, [_c('h1', [_vm._v(_vm._s(_vm.unsupported.heading))]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.unsupported.msg))])])])])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "exposures-carousel",
    attrs: {
      "id": "exposures-carousel"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "carousel-items"
  }, _vm._l((_vm.filteredExposures), function(exposure, index) {
    return _c('div', {
      staticClass: "carousel-item",
      on: {
        "click": function($event) {
          _vm.getExposure(exposure.exposure_slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": exposure.mobile.gridImageX1,
        "srcset": (exposure.mobile.gridImageX1 + ' 1x,' + exposure.mobile.gridImageX2 + ' 2x,' + exposure.mobile.gridImageX3 + ' 3x'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(exposure.exposure_label)
      }
    })])])
  }))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "interactive-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "mobile-interactive"
  }, [_c('section', {
    attrs: {
      "id": "base-container",
      "data-sticky-container": ""
    }
  }, [_c('header', {
    staticClass: "sticky",
    attrs: {
      "data-sticky-wrap": ""
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.loaded) ? _c('branding', {
    attrs: {
      "logo": _vm.company.logo,
      "altText": _vm.company.company_name,
      "link": _vm.company.url,
      "addClass": "mobile",
      "linkTarget": "_blank"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'not-entered': !_vm.hasEntered
    },
    attrs: {
      "data-sticky-container": ""
    }
  }, [_c('vue-tabs', {
    on: {
      "tab-change": _vm.handleTabChange
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('v-tab', {
    attrs: {
      "title": "Exposures"
    }
  }, [_c('mobile-content-exposures')], 1), _vm._v(" "), (_vm.hasCoverages) ? _c('v-tab', {
    attrs: {
      "title": _vm.addCoverageLabel
    }
  }, [_c('mobile-content-coverages')], 1) : _vm._e(), _vm._v(" "), _c('v-tab', {
    attrs: {
      "title": _vm.contactData.form_label
    }
  }, [_c('mobile-content-contact')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [(!_vm.hasEntered) ? _c('section', {
    class: {
      'active': !_vm.hasEntered
    },
    attrs: {
      "data-type": "landing"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('mobile-landing')], 1)]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "data-type": "privacy"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('mobile-content-privacy')], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "data-type": "terms"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('mobile-content-terms')], 1)])])], 1), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "share-control"
  }, [_c('a', {
    attrs: {
      "title": "Share"
    },
    on: {
      "click": _vm.shareApp
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_share",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('share-controls'), _vm._v(" "), _c('hr')], 1), _vm._v(" "), (_vm.contact.show) ? _c('div', {
    staticClass: "contact-link"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.text)
    }
  }), _vm._v(" "), _c('br'), _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contact.link.label)
    },
    on: {
      "click": function($event) {
        _vm.changeTab(_vm.contactData.form_label)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.disclaimerActive) ? _c('div', {
    staticClass: "disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.disclaimer)
    }
  }) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "legal"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "title": "Privacy Policy"
    },
    on: {
      "click": function($event) {
        _vm.showPanel('privacy')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "title": "Terms and Conditions"
    },
    on: {
      "click": function($event) {
        _vm.showPanel('terms');
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Terms and Conditions")])])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "exposures-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "exposures",
    attrs: {
      "id": "exposures"
    }
  }, [_c('transition', {
    attrs: {
      "name": "exposures-fade",
      "enter-active-class": "animated fadeIn"
    }
  }, [(!_vm.selectedSlug) ? _c('div', {
    key: "grid",
    staticClass: "grid-component",
    class: {
      'deactivate': _vm.selectedSlug
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.banner.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.banner.copy)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "exposures-grid"
  }, _vm._l((_vm.exposures), function(exposure, index) {
    return _c('div', {
      staticClass: "grid-item",
      on: {
        "click": function($event) {
          _vm.getExposure(exposure.exposure_slug)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": exposure.mobile.gridImageX1,
        "srcset": (exposure.mobile.gridImageX1 + ' 1x,' + exposure.mobile.gridImageX2 + ' 2x,' + exposure.mobile.gridImageX3 + ' 3x'),
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(exposure.exposure_label)
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "nav-to-top"
  }, [_c('a', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v("Back to Top "), _c('span', {
    staticClass: "glyph"
  }, [_vm._v("↑")])])])])])]) : _c('mobile-content-exposure', {
    key: "detail",
    attrs: {
      "slug": _vm.selectedSlug,
      "service": _vm.selectedService,
      "premise": _vm.selectedPremise
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.isLandscape) ? _c('div', {
    staticClass: "orientation-warning",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "mast"
  }, [(_vm.loaded) ? _c('branding', {
    attrs: {
      "logo": _vm.company.logo.path,
      "altText": _vm.company.company_name,
      "link": _vm.company.url,
      "linkTarget": "_blank"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "contact-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "banner"
  }, [(_vm.contact.form_header) ? _c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.form_intro) ? _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_intro)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [((_vm.contact.name && _vm.contact.show_company_name)) ? _c('div', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.name)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.address1) ? _c('div', {
    staticClass: "address"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.address1)
    }
  }), _vm._v(" "), (_vm.contact.address2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.address2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.city) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm.contact.city + ', ' + _vm.contact.state + ' ' + _vm.contact.zipcode))
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('div', {
    staticClass: "phone",
    domProps: {
      "innerHTML": _vm._s((((_vm.contact.fax) ? '(P) ' : '') + _vm.contact.phone))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.fax) ? _c('div', {
    staticClass: "fax",
    domProps: {
      "innerHTML": _vm._s((((_vm.contact.phone) ? '(F) ' : '') + _vm.contact.fax))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.email) ? _c('div', {
    staticClass: "email"
  }, [(_vm.isContactEmail(_vm.contact.email)) ? _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    attrs: {
      "href": 'mailto:' + (_vm.contact.email)
    }
  }, [_vm._v(_vm._s(_vm.contactUrlLabel))]) : _vm._e(), _vm._v(" "), (!_vm.isContactEmail(_vm.contact.email)) ? _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    attrs: {
      "href": _vm.contact.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.contactUrlLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.submitted) ? _c('div', {
    key: "contact-form-a"
  }, [(_vm.hasContactFields) ? _c('form', {
    attrs: {
      "id": "contact-form-a",
      "name": "contact-form-a",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleFormSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "required-note"
  }, [_vm._v("*Required")]), _vm._v(" "), (_vm.contactFieldVisibleBySlug('fullname')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('fullname')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "fullname",
      "name": "fullname",
      "placeholder": (_vm.contactFieldLabelBySlug('fullname')),
      "tabindex": "1",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('fullname')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "fullname",
      "name": "fullname",
      "placeholder": (_vm.contactFieldLabelBySlug('fullname')),
      "tabindex": "1"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('address-1')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('address-1')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-1",
      "name": "address-1",
      "placeholder": (_vm.contactFieldLabelBySlug('address-1')),
      "tabindex": "5",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('address-1')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-1",
      "name": "address-1",
      "placeholder": (_vm.contactFieldLabelBySlug('address-1')),
      "tabindex": "5"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('address-2')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('address-2')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-2",
      "name": "address-2",
      "placeholder": (_vm.contactFieldLabelBySlug('address-2')),
      "tabindex": "10",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('address-2')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-2",
      "name": "address-2",
      "placeholder": (_vm.contactFieldLabelBySlug('address-2')),
      "tabindex": "10"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('city')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('city')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "city",
      "name": "city",
      "placeholder": (_vm.contactFieldLabelBySlug('city')),
      "tabindex": "15",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('city')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "city",
      "name": "city",
      "placeholder": (_vm.contactFieldLabelBySlug('city')),
      "tabindex": "15"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.contactFieldVisibleBySlug('state') || _vm.contactFieldVisibleBySlug('zipcode'))) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldVisibleBySlug('state') && _vm.contactFieldRequiredBySlug('state')) ? _c('select', {
    staticClass: "flex-50",
    attrs: {
      "name": "state",
      "tabindex": "20",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.stateProvinceLabel) + "*")]), _vm._v(" "), _vm._l((_vm.stateProvinceOptions[_vm.form.country]), function(option) {
    return _c('option', {
      domProps: {
        "value": option.code
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('state') && !_vm.contactFieldVisibleBySlug('state')) ? _c('select', {
    staticClass: "flex-50",
    attrs: {
      "name": "state",
      "tabindex": "20",
      "required": _vm.contactFieldRequiredBySlug('state')
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.stateProvinceLabel) + "*")]), _vm._v(" "), _vm._l((_vm.stateProvinceOptions[_vm.form.country]), function(option) {
    return _c('option', {
      domProps: {
        "value": option.code
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('zipcode') && _vm.contactFieldRequiredBySlug('zipcode')) ? _c('input', {
    staticClass: "flex-50",
    attrs: {
      "type": "text",
      "id": "zipcode",
      "name": "zipcode",
      "value": "",
      "placeholder": (_vm.contactFieldLabelBySlug('zipcode')),
      "tabindex": "25",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('zipcode') && !_vm.contactFieldRequiredBySlug('zipcode')) ? _c('input', {
    staticClass: "flex-50",
    attrs: {
      "type": "text",
      "id": "zipcode",
      "name": "zipcode",
      "value": "",
      "placeholder": (_vm.contactFieldLabelBySlug('zipcode')),
      "tabindex": "25"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('country')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('country')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    attrs: {
      "id": "country",
      "name": "country",
      "tabindex": "30",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "US",
      "selected": ""
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")])]) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('country')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    attrs: {
      "id": "country",
      "name": "country",
      "tabindex": "30"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "US",
      "selected": ""
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('phone')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('phone')) ? _c('input', {
    attrs: {
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "placeholder": "Phone Number*",
      "tabindex": "35",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('phone')) ? _c('input', {
    attrs: {
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "placeholder": "Phone Number*",
      "tabindex": "35"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('email')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('email')) ? _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Email Address*",
      "tabindex": "40",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('email')) ? _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Email Address*",
      "tabindex": "40"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.contact.form_type === 'sign-up' && _vm.contactFieldVisibleBySlug('policy-number'))) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('policy-number')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "policy-number",
      "name": "policy-number",
      "placeholder": "Policy Number",
      "tabindex": "45",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('policy-number')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "policy-number",
      "name": "policy-number",
      "placeholder": "Policy Number",
      "tabindex": "45"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('contact-method')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('contact-method')) ? _c('select', {
    attrs: {
      "id": "contact-method",
      "name": "contact-method",
      "tabindex": "47",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "innerHTML": _vm._s((_vm.contactFieldLabelBySlug('contact-method')))
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])]) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('contact-method')) ? _c('select', {
    attrs: {
      "id": "contact-method",
      "name": "contact-method",
      "tabindex": "47"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "innerHTML": _vm._s((_vm.contactFieldLabelBySlug('contact-method')))
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row not-a-bot align-center justify-center"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "not-a-bot",
      "id": "not-a-bot",
      "tabindex": "50",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "not-a-bot"
    }
  }, [_vm._v("I am not a robot.*")])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-center justify-center"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      disabled: _vm.submitting
    },
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "type": "submit",
      "tabindex": "55",
      "disabled": _vm.submitting
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "form-row align-center justify-center"
  }, [_c('span', {
    staticClass: "note"
  }, [_vm._v("Transmitting your submission, please wait...")])]) : _vm._e()]), _vm._v(" "), (_vm.contact.slug) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "company",
      "name": "company"
    },
    domProps: {
      "value": _vm.contact.slug
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.form_type) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "form-type",
      "name": "form-type"
    },
    domProps: {
      "value": _vm.contact.form_type
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.submitted) ? _c('div', {
    key: "form-thanks",
    staticClass: "form-thanks"
  }, [_c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_thanks_title)
    }
  }), _vm._v(" "), (_vm.contact.form_thanks_msg) ? _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_thanks_msg)
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.backToExposures
    }
  }, [_vm._v("Back to Exposures")])]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.content.exposure_label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [(_vm.content.media.sources[0]) ? _c('div', {
    staticClass: "iconic"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.media.sources[0]
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "intro",
    domProps: {
      "innerHTML": _vm._s(_vm.content.lead_in)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.content.loss_example) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Loss Example")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.loss_example)
    }
  }), _vm._v(" "), (_vm.content.maintenance_tip) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.content.maintenance_tip) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Maintenance Tip")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.maintenance_tip)
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.disclaimer)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "return-home align-center justify-center"
  }, [_c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToHome
    }
  }, [_vm._v("Back to Home")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "noselect",
    class: _vm.it,
    style: ({
      borderTopColor: _vm.cssPropColor('$color-border')
    })
  }, [(_vm.loaded) ? _c('branding', {
    attrs: {
      "logo": _vm.company.logo,
      "altText": _vm.company.company_name,
      "link": _vm.company.url,
      "linkTarget": "_blank"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "company-nav-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown"
    }
  }, [(_vm.hasEntered) ? _c('nav', {
    staticClass: "company",
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border'),
      borderLeftColor: _vm.cssPropColor('$color-border')
    })
  }, [_c('ul', [((_vm.aboutPosition === 'footer')) ? _c('li', {
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border')
    })
  }, [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-about')
    },
    attrs: {
      "title": "About"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-about', 'about-us', $event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_information",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("About")])])]) : _vm._e(), _vm._v(" "), (_vm.hasCoverages) ? _c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-coverages')
    },
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border')
    }),
    attrs: {
      "title": "Additional Coverages"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-coverages', 'additional-coverages', $event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_additional",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.addCoverageLabel)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-contact')
    },
    style: ({
      borderRightColor: _vm.cssPropColor('$color-border')
    }),
    attrs: {
      "title": "Contact Us"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-contact', 'contact-us', $event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_contact",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_label)
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "legal-nav-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown"
    }
  }, [(_vm.hasEntered) ? _c('nav', {
    staticClass: "legal"
  }, [_c('ul', [_c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-privacy')
    },
    attrs: {
      "title": "Privacy Policy"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-privacy', 'privacy-policy', $event)
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: (_vm.activePanel === 'panel-content-terms')
    },
    attrs: {
      "title": "Terms and Conditions"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-terms', 'terms-of-service', $event)
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Terms and Conditions")])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cta-transition",
      "enter-active-class": "animated delay5s fadeIn",
      "leave-active-class": "animated delay0s fadeOut"
    }
  }, [(((_vm.hasEntered && _vm.display) && !_vm.powerSurge) && _vm.hasPowerSurge) ? _c('div', {
    staticClass: "power-surge-button noselect",
    attrs: {
      "title": _vm.label
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lightsOut($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "exposure-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "exposure-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeExposure
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.headerLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "exposure-content"
  }, [(_vm.content.lead_in) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.content.lead_in)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.content.media.sources.length)) ? _c('div', {
    staticClass: "media"
  }, [((_vm.content.media.type === 'images')) ? _c('div', {
    staticClass: "image-carousel"
  }, _vm._l((_vm.content.media.sources), function(image, idx) {
    return _c('img', {
      key: idx,
      attrs: {
        "src": image,
        "alt": ""
      }
    })
  })) : _vm._e(), _vm._v(" "), ((_vm.content.media.type === 'video')) ? _c('div', {
    staticClass: "video-player"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video', {
    attrs: {
      "id": "video-player",
      "src": _vm.content.media.sources[0],
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "controlsList": "nodownload"
    },
    domProps: {
      "muted": true
    }
  }, [_vm._v("\n                            Your browser does not support HTML5 video.\n                        ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.content.loss_example) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Loss Example")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.loss_example)
    }
  }), _vm._v(" "), _c('hr', {
    style: ({
      backgroundColor: _vm.cssPropColor('$color-divider')
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.content.maintenance_tip) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Maintenance Tip")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.maintenance_tip)
    }
  }), _vm._v(" "), _c('hr', {
    style: ({
      backgroundColor: _vm.cssPropColor('$color-divider')
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.content.pdf) ? _c('section', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.content.pdf,
      "title": "Download PDF",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackEvent('PDF Download', _vm.content.pdf)
      }
    }
  }, [_vm._v("Download PDF")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "0"
    },
    style: ({
      backgroundColor: _vm.cssPropColor('$color-divider')
    })
  })]) : _vm._e(), _vm._v(" "), ((_vm.service || _vm.premise)) ? _c('div', {
    staticClass: "related"
  }, [((_vm.premise)) ? _c('div', {
    staticClass: "cta-text",
    domProps: {
      "innerHTML": _vm._s(_vm.coverageContent.cta_offpremise)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.premise)) ? _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "title": _vm.labelOffPremise
    },
    domProps: {
      "innerHTML": _vm._s(_vm.labelOffPremise)
    },
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.addCoverageLabel, 'off-premise', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.service)) ? _c('div', {
    staticClass: "cta-text",
    domProps: {
      "innerHTML": _vm._s(_vm.coverageContent.cta_serviceline)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.service)) ? _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "title": _vm.labelServiceLine
    },
    domProps: {
      "innerHTML": _vm._s(_vm.labelServiceLine)
    },
    on: {
      "click": function($event) {
        _vm.togglePanel(_vm.addCoverageLabel, 'service-line', false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()])]), _vm._v(" "), _c('exposures-carousel', {
    attrs: {
      "selectedSlug": _vm.slug
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cta-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [((_vm.hasEntered && _vm.display)) ? _c('div', {
    staticClass: "interaction-cta noselect",
    class: {
      tablet: _vm.isTablet
    }
  }, [(!_vm.isTablet) ? _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon-move@1x.png",
      "srcset": "/static/images/icon-move@1x.png 1x, /static/images/icon-move@2x.png 2x, /static/images/icon-move@3x.png 3x",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.message))])]) : _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon-touch@1x.png",
      "srcset": "/static/images/icon-touch@1x.png 1x, /static/images/icon-touch@2x.png 2x, /static/images/icon-touch@3x.png 3x",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon-pinch@1x.png",
      "srcset": "/static/images/icon-pinch@1x.png 1x, /static/images/icon-pinch@2x.png 2x, /static/images/icon-pinch@3x.png 3x",
      "alt": ""
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "panel-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "cta-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.powerSurgeOverlay) ? _c('div', {
    staticClass: "overlay"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-controls",
    class: {
      'open': _vm.activeShare
    }
  }, [_c('div', {
    staticClass: "addthis_toolbox addthis_default_style addthis_32x32_style"
  }, [((_vm.shareData.facebook === '1')) ? _c('a', {
    staticClass: "addthis_button_facebook",
    attrs: {
      "addthis:service": "facebook",
      "addthis:url": _vm.shareUrl,
      "addthis:title": _vm.shareMessage,
      "addthis:description": _vm.shareMessage,
      "title": "Share on Facebook"
    },
    on: {
      "click": _vm.closeShares
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), ((_vm.shareData.linkedin === '1')) ? _c('a', {
    staticClass: "addthis_button_linkedin",
    attrs: {
      "addthis:service": "linkedin",
      "addthis:url": _vm.shareUrl,
      "addthis:title": _vm.shareTitle,
      "addthis:description": _vm.shareMessage,
      "title": "Share on LinkedIn"
    },
    on: {
      "click": _vm.closeShares
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), ((_vm.shareData.twitter === '1')) ? _c('a', {
    staticClass: "addthis_button_twitter",
    attrs: {
      "addthis:service": "twitter",
      "addthis:url": _vm.shareUrl,
      "addthis:title": _vm.shareMessage,
      "addthis:description": _vm.shareMessage,
      "title": "Share on Twitter"
    },
    on: {
      "click": _vm.closeShares
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), ((_vm.shareData.google_plus === '1')) ? _c('a', {
    staticClass: "addthis_button_google_plusone_share",
    attrs: {
      "addthis:service": "googleplus",
      "addthis:url": _vm.shareUrl,
      "addthis:title": _vm.shareMessage,
      "addthis:description": _vm.shareMessage,
      "title": "Share on Google+"
    },
    on: {
      "click": _vm.closeShares
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), ((_vm.shareData.email === '1')) ? _c('a', {
    staticClass: "addthis_button_email",
    attrs: {
      "addthis:service": "email",
      "addthis:url": _vm.shareUrl,
      "addthis:title": _vm.shareTitle,
      "addthis:description": _vm.shareMessage,
      "addthis:note": _vm.shareMessage,
      "title": "Share via Email"
    },
    on: {
      "click": _vm.closeShares
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "residence",
    class: {
      zoomed: _vm.isZoomed
    }
  }, [_c('div', {
    attrs: {
      "id": "base-container"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "coverages-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "mast-head"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.addCoverageLabel)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "accordion"
  }, [(_vm.hasServiceLineCoverages) ? _c('li', {
    attrs: {
      "data-type": "service-line"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_service-line",
      "name": "anchor_service-line"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-service-line"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.serviceLineLeadIn) ? _c('div', {
    staticClass: "lead-in service-line",
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.serviceLineCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, true, false)
        }
      }
    })])
  }))]), _vm._v(" "), (_vm.hasOffPremiseCoverages) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasOffPremiseCoverages) ? _c('li', {
    attrs: {
      "data-type": "off-premise"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_off-premise",
      "name": "anchor_off-premise"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-off-premise"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.offPremiseLeadIn) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.offPremiseCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, false, true)
        }
      }
    })])
  }))])]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [((!_vm.isPortrait && !_vm.is404)) ? _c('div', {
    staticClass: "orientation-warning-mobile",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.addCoverageLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('ul', {
    staticClass: "accordion"
  }, [(_vm.hasServiceLineCoverages) ? _c('li', {
    attrs: {
      "data-type": "service-line"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_service-line",
      "name": "anchor_service-line"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "tab-service-line",
      "name": "outer-tabs[]",
      "data-coverage": "service-line"
    },
    domProps: {
      "checked": _vm.service
    },
    on: {
      "change": function($event) {
        _vm.toggleOuterCheck($event, 'tab-service-line')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-service-line"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.serviceLineLeadIn) ? _c('div', {
    staticClass: "lead-in service-line",
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.serviceLineCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, true, false)
        }
      }
    })])
  }))]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.hasOffPremiseCoverages) ? _c('li', {
    attrs: {
      "data-type": "off-premise"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_off-premise",
      "name": "anchor_off-premise"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "tab-off-premise",
      "name": "outer-tabs[]",
      "data-coverage": "off-premise"
    },
    domProps: {
      "checked": _vm.premise
    },
    on: {
      "change": function($event) {
        _vm.toggleOuterCheck($event, 'tab-off-premise')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-off-premise"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.offPremiseLeadIn) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.offPremiseCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, false, true)
        }
      }
    })])
  }))]), _vm._v(" "), _c('hr')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-link"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.text)
    }
  }), _vm._v(" "), _c('br'), _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.link.label)
    },
    on: {
      "click": function($event) {
        _vm.togglePanel2('panel-content-contact', 'contact-us', $event, false, false)
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "landing-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [(!_vm.hasEntered) ? _c('div', {
    staticClass: "landing",
    attrs: {
      "data-size": "sm"
    }
  }, [(_vm.hasSupport) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "intro-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.houseImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduction"
  }, [_c('h1', [_vm._v(_vm._s(_vm.landing.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.landing.tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "breakdown-insurance"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [((_vm.aboutContent.about_heading_1 || _vm.aboutContent.about_body_1)) ? _c('section', [(_vm.aboutContent.about_heading_1) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_heading_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutContent.about_body_1) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_body_1)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), ((_vm.aboutContent.about_heading_2 || _vm.aboutContent.about_body_2)) ? _c('section', [(_vm.aboutContent.about_heading_2) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_heading_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutContent.about_body_2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_body_2)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('progress-button', {
    attrs: {
      "method": _vm.openSesames,
      "loadingLabel": _vm.loadingLabel,
      "readyLabel": _vm.buttonLabel
    }
  })], 1)])])]) : _c('div', {
    staticClass: "content unsupported"
  }, [_c('h1', [_vm._v(_vm._s(_vm.unsupported.heading))]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.unsupported.msg))])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-panel",
    class: {
      open: _vm.panelOpen
    },
    on: {
      "click": function($event) {
        _vm.panelDown($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.panelOpen),
      expression: "panelOpen"
    }],
    attrs: {
      "type": "checkbox",
      "id": "panel-toggle",
      "name": "panel-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.panelOpen) ? _vm._i(_vm.panelOpen, null) > -1 : (_vm.panelOpen)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.panelOpen,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.panelOpen = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.panelOpen = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.panelOpen = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-container"
  }, [_c('transition', {
    attrs: {
      "name": "sbfade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.activePanel) ? _c(_vm.activePanel.panel, {
    tag: "component",
    attrs: {
      "slug": _vm.activePanel.slug,
      "service": _vm.activePanel.service,
      "premise": _vm.activePanel.premise
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.headerLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [(_vm.content.lead_in) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.content.lead_in)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.content.media.sources.length)) ? _c('div', {
    staticClass: "media"
  }, [((_vm.content.media.type === 'images')) ? _c('div', {
    staticClass: "image-carousel"
  }, _vm._l((_vm.content.media.sources), function(image, idx) {
    return _c('img', {
      key: idx,
      attrs: {
        "src": image,
        "alt": ""
      }
    })
  })) : _vm._e(), _vm._v(" "), ((_vm.content.media.type === 'video')) ? _c('div', {
    staticClass: "video-player"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video', {
    attrs: {
      "id": "video-player",
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "controlsList": "nodownload"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.media.sources[0],
      "type": "video/mp4"
    }
  }), _vm._v("\n                        Your browser does not support HTML5 video.\n                    ")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.content.loss_example) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Loss Example")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.loss_example)
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.content.maintenance_tip) ? _c('section', [_c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    })
  }, [_vm._v("Maintenance Tip")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.maintenance_tip)
    }
  }), _vm._v(" "), _c('hr', {
    class: {
      'invisible': _vm.content.pdf
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content.pdf) ? _c('section', {
    staticClass: "exposure-pdf"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.content.pdf,
      "title": "Download PDF",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackEvent('PDF Download', _vm.content.pdf)
      }
    }
  }, [_vm._v("Download PDF")]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), ((_vm.service || _vm.premise)) ? _c('div', {
    staticClass: "related"
  }, [((_vm.premise)) ? _c('div', {
    staticClass: "cta-text",
    domProps: {
      "innerHTML": _vm._s(_vm.coverageContent.cta_offpremise)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.premise)) ? _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "title": _vm.labelOffPremise
    },
    domProps: {
      "innerHTML": _vm._s(_vm.labelOffPremise)
    },
    on: {
      "click": function($event) {
        _vm.$parent.togglePanel('panel-content-coverages', 'additional-coverages', $event, false, true)
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.service)) ? _c('div', {
    staticClass: "cta-text",
    domProps: {
      "innerHTML": _vm._s(_vm.coverageContent.cta_serviceline)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.service)) ? _c('button', {
    staticClass: "btn",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "title": _vm.labelServiceLine
    },
    domProps: {
      "innerHTML": _vm._s(_vm.labelServiceLine)
    },
    on: {
      "click": function($event) {
        _vm.$parent.togglePanel('panel-content-coverages', 'additional-coverages', $event, true, false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contact-link"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.text)
    }
  }), _vm._v(" "), _c('br'), _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contact.link.label)
    },
    on: {
      "click": function($event) {
        _vm.$parent.togglePanel('panel-content-contact', 'contact-us', $event);
        _vm.trackEvent('Contact Us Link', 'Exposure Panel');
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.disclaimer)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_download",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.hasEntered) ? _c('div', {
    staticClass: "overlay",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-overlay')
    }),
    on: {
      "~click": function($event) {
        $event.preventDefault();
        _vm.openSesame($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [((_vm.content.about_heading_1 || _vm.content.about_body_1)) ? _c('section', [(_vm.content.about_heading_1) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_heading_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.about_body_1) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_body_1)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.content.about_heading_2 || _vm.content.about_body_2)) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.content.about_heading_2 || _vm.content.about_body_2)) ? _c('section', [(_vm.content.about_heading_2) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_heading_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.about_body_2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.about_body_2)
    }
  }) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "panel-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('button', {
    class: {
      'ready color-bg-primary': _vm.loaded, 'color-base-text': !_vm.loaded
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loaded) ? _c('span', {
    key: "loaded",
    staticClass: "label loaded",
    domProps: {
      "innerHTML": _vm._s(_vm.buttonLabel)
    }
  }) : _c('span', {
    key: "loading",
    staticClass: "label loading",
    domProps: {
      "innerHTML": _vm._s(_vm.buttonLabel)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress"
  }, [_c('span', {
    staticClass: "indicator",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_label)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_header)
    }
  }), _vm._v(" "), (_vm.contact.form_intro) ? _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_intro)
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.contact.name && _vm.contact.show_company_name)) ? _c('div', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.name)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.address1) ? _c('div', {
    staticClass: "address"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.address1)
    }
  }), _vm._v(" "), (_vm.contact.address2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.address2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.city) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm.contact.city + ', ' + _vm.contact.state + ' ' + _vm.contact.zipcode))
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('div', {
    staticClass: "phone",
    domProps: {
      "innerHTML": _vm._s((((_vm.contact.fax) ? '(P) ' : '') + _vm.contact.phone))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.fax) ? _c('div', {
    staticClass: "fax",
    domProps: {
      "innerHTML": _vm._s((((_vm.contact.phone) ? '(F) ' : '') + _vm.contact.fax))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.email) ? _c('div', {
    staticClass: "email"
  }, [(_vm.isContactEmail(_vm.contact.email)) ? _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    attrs: {
      "href": 'mailto:' + (_vm.contact.email)
    }
  }, [_vm._v(_vm._s(_vm.contact.email))]) : _vm._e(), _vm._v(" "), (!_vm.isContactEmail(_vm.contact.email)) ? _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    attrs: {
      "href": _vm.contact.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.contactUrlLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.submitted) ? _c('div', {
    key: "contact-form-a"
  }, [(_vm.hasContactFields) ? _c('form', {
    attrs: {
      "id": "contact-form-a",
      "name": "contact-form-a",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleFormSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "required-note"
  }, [_vm._v("*Required")]), _vm._v(" "), (_vm.contactFieldVisibleBySlug('fullname')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('fullname')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "fullname",
      "name": "fullname",
      "placeholder": (_vm.contactFieldLabelBySlug('fullname')),
      "tabindex": "1",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('fullname')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "fullname",
      "name": "fullname",
      "placeholder": (_vm.contactFieldLabelBySlug('fullname')),
      "tabindex": "1"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('address-1')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('address-1')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-1",
      "name": "address-1",
      "placeholder": (_vm.contactFieldLabelBySlug('address-1')),
      "tabindex": "5",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('address-1')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-1",
      "name": "address-1",
      "placeholder": (_vm.contactFieldLabelBySlug('address-1')),
      "tabindex": "5"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('address-2')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('address-2')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-2",
      "name": "address-2",
      "placeholder": (_vm.contactFieldLabelBySlug('address-2')),
      "tabindex": "10",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('address-2')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "address-2",
      "name": "address-2",
      "placeholder": (_vm.contactFieldLabelBySlug('address-2')),
      "tabindex": "10"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('city')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('city')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "city",
      "name": "city",
      "placeholder": (_vm.contactFieldLabelBySlug('city')),
      "tabindex": "15",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('city')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "city",
      "name": "city",
      "placeholder": (_vm.contactFieldLabelBySlug('city')),
      "tabindex": "15"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.contactFieldVisibleBySlug('state') || _vm.contactFieldVisibleBySlug('zipcode'))) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldVisibleBySlug('state') && _vm.contactFieldRequiredBySlug('state')) ? _c('select', {
    staticClass: "flex-50",
    attrs: {
      "name": "state",
      "tabindex": "20",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.stateProvinceLabel) + "*")]), _vm._v(" "), _vm._l((_vm.stateProvinceOptions[_vm.form.country]), function(option) {
    return _c('option', {
      domProps: {
        "value": option.code
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('state') && !_vm.contactFieldRequiredBySlug('state')) ? _c('select', {
    staticClass: "flex-50",
    attrs: {
      "name": "state",
      "tabindex": "20"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.stateProvinceLabel))]), _vm._v(" "), _vm._l((_vm.stateProvinceOptions[_vm.form.country]), function(option) {
    return _c('option', {
      domProps: {
        "value": option.code
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('zipcode') && _vm.contactFieldRequiredBySlug('zipcode')) ? _c('input', {
    staticClass: "flex-50",
    attrs: {
      "type": "text",
      "id": "zipcode",
      "name": "zipcode",
      "value": "",
      "placeholder": (_vm.contactFieldLabelBySlug('zipcode')),
      "tabindex": "25",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('zipcode') && !_vm.contactFieldRequiredBySlug('zipcode')) ? _c('input', {
    staticClass: "flex-50",
    attrs: {
      "type": "text",
      "id": "zipcode",
      "name": "zipcode",
      "value": "",
      "placeholder": (_vm.contactFieldLabelBySlug('zipcode')),
      "tabindex": "25"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('country')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('country')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    attrs: {
      "id": "country",
      "name": "country",
      "tabindex": "30",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "US",
      "selected": ""
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")])]) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('country')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    attrs: {
      "id": "country",
      "name": "country",
      "tabindex": "30"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "US",
      "selected": ""
    }
  }, [_vm._v("United States")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('phone')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('phone')) ? _c('input', {
    attrs: {
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "placeholder": (_vm.contactFieldLabelBySlug('phone')),
      "tabindex": "35",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('phone')) ? _c('input', {
    attrs: {
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "placeholder": (_vm.contactFieldLabelBySlug('phone')),
      "tabindex": "35"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('email')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('email')) ? _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": (_vm.contactFieldLabelBySlug('email')),
      "tabindex": "40",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('email')) ? _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": (_vm.contactFieldLabelBySlug('email')),
      "tabindex": "40"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.contact.form_type === 'sign-up' && _vm.contactFieldVisibleBySlug('policy-number'))) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('policy-number')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "policy-number",
      "name": "policy-number",
      "placeholder": "Policy Number",
      "tabindex": "45",
      "required": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('policy-number')) ? _c('input', {
    attrs: {
      "type": "text",
      "id": "policy-number",
      "name": "policy-number",
      "placeholder": "Policy Number",
      "tabindex": "45"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contactFieldVisibleBySlug('contact-method')) ? _c('div', {
    staticClass: "form-row"
  }, [(_vm.contactFieldRequiredBySlug('contact-method')) ? _c('select', {
    attrs: {
      "id": "contact-method",
      "name": "contact-method",
      "tabindex": "47",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "innerHTML": _vm._s((_vm.contactFieldLabelBySlug('contact-method')))
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])]) : _vm._e(), _vm._v(" "), (!_vm.contactFieldRequiredBySlug('contact-method')) ? _c('select', {
    attrs: {
      "id": "contact-method",
      "name": "contact-method",
      "tabindex": "47"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "innerHTML": _vm._s((_vm.contactFieldLabelBySlug('contact-method')))
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v("Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-row align-center justify-center"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      disabled: _vm.submitting
    },
    style: ({
      backgroundColor: _vm.cssPropColor('$color-secondary')
    }),
    attrs: {
      "type": "submit",
      "tabindex": "55",
      "disabled": _vm.submitting
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "form-row align-center justify-center"
  }, [_c('span', {
    staticClass: "note"
  }, [_vm._v("Transmitting your submission, please wait...")])]) : _vm._e()]), _vm._v(" "), (_vm.contact.slug) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "company",
      "name": "company"
    },
    domProps: {
      "value": _vm.contact.slug
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contact.form_type) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "form-type",
      "name": "form-type"
    },
    domProps: {
      "value": _vm.contact.form_type
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.submitted) ? _c('div', {
    key: "form-thanks",
    staticClass: "form-thanks"
  }, [_c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_thanks_title)
    }
  }), _vm._v(" "), (_vm.contact.form_thanks_msg) ? _c('div', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.form_thanks_msg)
    }
  }) : _vm._e()]) : _vm._e()])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row not-a-bot align-center justify-center"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "not-a-bot",
      "id": "not-a-bot",
      "tabindex": "50",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "not-a-bot"
    }
  }, [_vm._v("I am not a robot.*")])])
}]}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "branding",
    class: [_vm.imageOrientationClass, _vm.addClass]
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pageHref,
      "title": _vm.altText
    },
    on: {
      "click": _vm.trackEvent
    }
  }, [_c('img', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded:on.progress",
      value: (_vm.imageProgress),
      expression: "imageProgress",
      arg: "on",
      modifiers: {
        "progress": true
      }
    }],
    attrs: {
      "srcset": _vm.getImgSrcSet(_vm.logo),
      "src": _vm.logo.x1.url,
      "alt": _vm.altText
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    on: {
      "click": function($event) {
        _vm.panelDown($event)
      }
    }
  }, [_c('ul', {
    staticClass: "controls"
  }, [_c('li', [_c('a', {
    class: {
      active: (_vm.zoomed), disabled: (_vm.surging)
    },
    attrs: {
      "title": "Zoom In"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: (!_vm.zoomed), disabled: (_vm.surging)
    },
    attrs: {
      "title": "Zoom Out"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "title": "Share"
    },
    on: {
      "click": _vm.shareApp
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('share-controls')], 1), _vm._v(" "), (_vm.pdfDownload) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.pdfDownload) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.pdfDownload,
      "title": "Download PDF",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackEvent('PDF Download', _vm.pdfDownload)
      }
    }
  }, [_vm._m(3)])]) : _vm._e(), _vm._v(" "), ((_vm.aboutPosition === 'sidebar')) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _c('li', [((_vm.aboutPosition === 'sidebar')) ? _c('a', {
    attrs: {
      "title": "About"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-about', 'about-us', $event)
      }
    }
  }, [_vm._m(4)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_zoom-in",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_zoom-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_share",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_download",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_information",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('orientation-warning'), _vm._v(" "), (_vm.isMobile) ? _c('orientation-warning-mobile') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'entering': !_vm.hasEntered, 'mobile': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "interactive",
    class: {
      'mobile': _vm.isMobile
    }
  }, [(!_vm.isMobile) ? _c('overlay', [_c('landing')], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile && _vm.has404) ? _c('div', {
    staticClass: "err-404"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.has404) ? _c('h1', [_vm._v(_vm._s(_vm.status.err404.title))]) : _vm._e(), _vm._v(" "), (_vm.has404) ? _c('h2', [_vm._v(_vm._s(_vm.status.err404.msg))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('power-surge-button') : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('power-surge-overlay') : _vm._e(), _vm._v(" "), _c('interaction-cta'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('keep-alive', [(!_vm.loadingData) ? _c('router-view') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.hasEntered && _vm.controlsEntered && !_vm.isMobile) ? _c('sidebar-panel') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "footer-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown",
      "appear": ""
    }
  }, [(!_vm.isMobile) ? _c('app-footer') : _vm._e()], 1)], 1), _vm._v(" "), (_vm.hasEntered && !_vm.isMobile) ? _c('sidebar-controls') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[72]);


// WEBPACK FOOTER //
// static/js/app.ad998364ce95a48242ee.js